import { React, useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import upgrade from "../../../Assets/Icons/up-range.svg";
import downgrade from "../../../Assets/Icons/down-range.svg";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap1,
  TableLayoutData,
  ContentMiddle,
  //   PipeDesign,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Tabs,
  Row,
  Col,
  Table,
  Tooltip,
  Progress,
  // Radio,
} from "antd";
import { Styled, RadioButtonStyle } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { TableList, RightSideSolution } from "../../pageStyled";
// import { HaberForm } from "../../styledElements";
import {
  getFailedGroups,
  // getJobCardCylinders,
  getJobCardsById,
  getJobCardsDetails,
  putSolutionStatus,
  cancelJobCard,
  getAlgorithmCompletionStatus,
  createNewSolution,
  createNewSheetSolution,
  putSheetSolutionStatus,
  createNewDuplexSolution,
  putDuplexSolutionStatus,
  unselectGrpOfAcceptedJobcards,
  getAlgorithmCompletionStatusOfSimplexNewSol,
  getAlgorithmCompletionStatusOfDuplexNewSol,
} from "../../../Services/deckleMatchServices";
import { getOrdersList } from "../../../Services/orderServices";
import moment from "moment";
import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
import IcoMoon from "react-icomoon";
import deckleCover from "../../../Assets/Images/deckle-match-result-cover.svg";
import warningjob from "../../../Assets/Icons/warningjob.svg";
import vectorIco from "../../../Assets/Icons/vectorIco.svg";
import alerttrue from "../../../Assets/Icons/alerttrue.svg";
import wrongIco from "../../../Assets/Icons/wrongIco.svg";
import failedIco from "../../../Assets/Icons/failedIco.svg";
import greaterRange from "../../../Assets/Icons/up-range.svg";
import lowerRange from "../../../Assets/Icons/down-range.svg";
import { getStockSizesDetailsByIds } from "../../../Services/productServices";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import { useInterval } from "../../../Utils/polling/pollingConfig";
import CreateNewSolution from "../DeckleResults/createNewSolution";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import LottieAnimation from "../../../Lottie";
import SheetJobCardCylinderContainer from "../../../Components/JobCardCylinders/SheetJobCardCylinderContainer";
import { jobcardJson, toFixedValue, toHandlePOName } from "../../../Utils/helper/helper";
import CreateNewSheetSolution from "./createNewSheetSolution";
import DuplexJobCardCylinderContainer from "../../../Components/JobCardCylinders/DuplexJobCardCylinderContainer";
import {
  lengthUnit,
  weightUnit,
  currency_List,
  CoversionFactorUnitsToCM,
  CoversionFactorCMToUnits

} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { getUnitData } from "../../../Services/measurementService";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext.jsx";

const gridViewData = [
  {
    label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
    value: "grid",
  },
  { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
];

const { TabPane } = Tabs;
const Panes = Tabs.TabPane;

function onChange(pagination, filters, sorter, extra) {
  console.log("params", pagination, filters, sorter, extra);
}
const getJCCode = (str) => {
  if (str) {
    let splittedString = str?.split("~");
    let mergeString;
    mergeString = splittedString?.join("");
    return mergeString;
  }
}
const SheetDeckleResultsData = (props) => {
  const stopCancellApi = useRef(false);
  const { stopCancelled, setStopCancelled, handleResetAll, handleBackPathForJC, setAcceptedJCGrpCode, acceptedJCGrpCode, removeGrpsFromOrderSummary } = useContext(JobCardDataContext);
  const [isAcceptModal, setIsAcceptModal] = useState(false);
  const [isDiscardModal, setIsDiscardModal] = useState(false);
  const location = useLocation();
  const [isGoBack, setIsGoBack] = useState(false);

  const [paperMachineFormValues, setPaperMachineFormValues] = useState(
    getFormObject()
  );
  const [formValuesForStock, setFormValuesForStock] = useState({});
  const [jobcardIds, setJobcardIds] = useState(
    location.state?.jobCards.jobcards
  );
  const [products, setProducts] = useState();
  const [failedGroups, setFailedGroups] = useState(
    location.state?.jobCards.failed_groups
  );

  const [totalGroups, setTotalGroups] = useState(
    location.state?.jobCards.total_groups
  );

  const isCancelJobCard = useRef(true);

  // const [fetchFailed, setFetchFailed] = useState(
  //   jobcardIds.length < totalGroups
  // );
  const [fetchFailed, setFetchFailed] = useState(false);
  const [jobIndex, setJobIndex] = useState(0);
  const [failedjobIndex, setFailedjobIndex] = useState(0);

  const [jobCardDetailsList, setJobCardDetailsList] = useState([]);
  const [solutionId, setSolutionId] = useState("1");
  const [failedJobs, setFailedJobs] = useState();

  const [orderDetailsList1, setOrderDetailsList1] = useState();
  const [orderDetailsList2, setOrderDetailsList2] = useState();
  const [stockSizeDetailsList1, setStockSizeDetailsList1] = useState();
  const [stockSizeDetailsList2, setStockSizeDetailsList2] = useState();
  const [failedJobOrders, setFailedJobOrders] = useState();
  const [reFetch, setReFetch] = useState(true);
  const [viewOrder, setViewOrder] = useState(false);
  const [selectedOrderNo, setSelectedOrderNo] = useState();
  const [selectedOrder, setSelectedOrder] = useState();

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [createNewSolutionClicked, setCreateNewSolutionClicked] = useState({
    isClicked: false,
    index: -1,
  });
  const [pendingJobCardsForNewSol, setPendingJobCardsForNewSol] = useState([]);
  const [fetchQueue, setFetchQueue] = useState([]);
  const [isProcessingFetchQueue, setIsProcessingFetchQueue] = useState(false);
  const [rerendering, setRerendering] = useState(false);
  const [stockSizes, setStockSizes] = useState([]);
  const [stockSizesByJobCard, setStockSizesByJobCard] = useState({});
  const [
    createNewSolutionFormValuesByJobCard,
    setCreateNewSolutionFormValuesByJobCard,
  ] = useState({});
  const [showAimation, setShowAimation] = useState({});
  const [solId, setSolId] = useState("1");
  const [sizeFulfillmentSolution1, setSizeFulfillmentSolution1] = useState();
  const [sizeFulfillmentSolution2, setSizeFulfillmentSolution2] = useState();
  const [sizeFulfillmentNewSolution1, setSizeFulfillmentNewSolution1] =
    useState();
  const [sizeFulfillmentNewSolution2, setSizeFulfillmentNewSolution2] =
    useState();
  const [unitData, setUnitData] = useState();
  const [activeJC, setActiveJC] = useState();
  const [jobcardIdsWithCode, setJobcardIdsWithCode] = useState([]);
  const [renderKey, setRenderKey] = useState(false);
  const currentActiveJC = useRef();
  const [sizeExpanded, setSizeExpanded] = useState(false);
  // const [sizeExpanded, setSizeExpanded] = useState(false); 
  // const [sizeExpanded, setSizeExpanded] = useState(false); 
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [ordersIdList, setOrderIdList] = useState([]);
  const [ordersIdListByJobCard, setOrdersIdListByJobCard] = useState({});

  // const [posList, setPosList] = useState([]);

  // const [acceptSolution, setAcceptSolution] = useState({
  //   solution1: "open",
  //   solution2: "open",
  // });

  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

  const cutter = location?.state?.replan_cutter_data || location?.state?.cutter_data?.find((data) => data.code == location?.state?.body?.cutter_code);

  const history = useNavigate();
  const selectedJobCardId = jobCardDetailsList?.[jobIndex]?.id;
  const defaultOrdersIdList =
    jobCardDetailsList?.[jobIndex]?.jobcard?.group?.orders?.map(
      (order) => order.order_id
    ) || [];
  const currentOrdersIdList = selectedJobCardId
    ? (ordersIdListByJobCard[selectedJobCardId] ?? defaultOrdersIdList)
    : [];
  useEffect(() => {
    (async () => {

      getUnitData().then((response) => {
        setUnitData(response.data);

      })
        .catch((error) => {
          console.log(error);
        });

    })();
  }, []);

  useEffect(async () => {
    return async () => {
      if (isCancelJobCard.current) {
        await setFormObject(null);
      }
    };
  }, []);

  useInterval(async () => {
    if (pendingJobCardsForNewSol.length === 0) return;

    const type = pendingJobCardsForNewSol[0].type;
    let completedUuids = [];
    let newFetches = [];

    try {
      const readyResp =
        type === "simplex"
          ? await getAlgorithmCompletionStatusOfSimplexNewSol()
          : await getAlgorithmCompletionStatusOfDuplexNewSol();

      if (readyResp?.data?.jobcard_output_mapping) {
        for (let pending of pendingJobCardsForNewSol) {
          const actualJobCardId =
            readyResp.data.jobcard_output_mapping[pending.requestJobcard] ||
            readyResp.data.jobcard_output_mapping[pending.jobCardId];
          if (actualJobCardId) {
            newFetches.push({ actualJobCardId, jobCardId: pending.jobCardId, uuid: pending.uuid });
            completedUuids.push(pending.uuid);
          }
        }
      }
    } catch (err) {
      console.error(`Error polling ${type} status`, err);
    }

    if (newFetches.length > 0) {
      setFetchQueue(prev => [...prev, ...newFetches]);
    }

    if (completedUuids.length > 0) {
      setPendingJobCardsForNewSol((prev) =>
        prev.filter((p) => !completedUuids.includes(p.uuid))
      );
    }
  }, pendingJobCardsForNewSol.length > 0 ? 3000 : null);

  useEffect(() => {
    if (isProcessingFetchQueue || fetchQueue.length === 0) return;
    const nextFetch = fetchQueue[0];
    setIsProcessingFetchQueue(true);
    getJobCardsListDetails([nextFetch.actualJobCardId], nextFetch.jobCardId, nextFetch.uuid, true)
      .finally(() => {
        setFetchQueue(prev => prev.slice(1));
        setIsProcessingFetchQueue(false);
      });
  }, [fetchQueue, isProcessingFetchQueue]);

  const routeChange = async () => {
    isCancelJobCard.current = false;
    setIsGoBack(true);
    setStopCancelled(true);
    stopCancellApi.current = true;
    setFormObject(paperMachineFormValues);
    // setFormObject(formValues);
    if (acceptedJCGrpCode.length > 0) {
      await unselectGrpOfAcceptedJobcards(acceptedJCGrpCode)
        .then((res) => {
          console.log(res);
          removeGrpsFromOrderSummary(res.data.data)
        })
        .catch((err) => console.log(err));
    }
    history(handleBackPathForJC() ? "../order-summary" : "../create-new-job-cards", {
      state: {
        body: location.state.body,
        orderResponse: location.state.orderResponse,
        maximum_burst_factor: location.state.maximum_burst_factor,
        minimum_burst_factor: location.state.minimum_burst_factor,
        maximum_gsm: location.state.maximum_gsm,
        minimum_gsm: location.state.minimum_gsm,
        selected_rewinder: location.state.selected_rewinder,
        selected_cutter: location.state.selected_cutter,
        selected_rewinder_unit: location.state.selected_rewinder_unit,
        selected_cutter_unit: location.state.selected_cutter_unit,
        rewinder_data: location.state.rewinder_data,
        cutter_data: location.state.cutter_data,
        selected_type: location.state.selected_type,
        rewinder_minWidth: location.state.rewinder_minWidth,
        rewinder_maxWidth: location.state.rewinder_maxWidth,
        cutter_minWidth: location.state.cutter_minWidth,
        cutter_maxWidth: location.state.cutter_maxWidth,
        max_NoOfCutters: location.state.max_NoOfCutters,
        minWeight: location.state.minWeight,
        minWeight: location.state.minWeight,
        left_edge_trim: location.state.left_edge_trim,
        right_edge_trim: location.state.right_edge_trim,
        code: location.state.code,
        machine_code: location.state.machine_code,
        partitionWeightUnit: location.state.partitionWeightUnit,
        processType: location.state.processType,
        initital_OrderType: location.state.initital_OrderType,
      }
    });
  };
  // Discard modal condition

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // process failed groups to fetch and set to failedGroups
  async function process_failed_groups() {
    let jobcardResp;
    while (true) {
      try {
        // keep checking the algo status
        const response = await getAlgorithmCompletionStatus();
        jobcardResp = response;
        if (response.data.total_groups == response.data.jobcards.length) {
          setJobcardIds(response.data.jobcards);
          setReFetch(true);
          break;
        }
        if (response.data.done && response.data.failed_groups.length > 0) {
          setFailedGroups(response.data.failed_groups);
          break;
        }
      } catch (error) {
        // console.log(error);
        return;
      } finally {
      }
      await sleep(5000);
    }
    if (jobcardResp.data.done && (jobcardResp.data.jobcards.length + jobcardResp.data.failed_groups.length) !== jobcardResp.data.total_groups) {
      setTimeout(async () => {
        const response = await getAlgorithmCompletionStatus();
        setFailedGroups(response.data.failed_groups);
      }, 180000);
    }
  }

  useEffect(() => {
    setTimeout(process_failed_groups, 5000);
  }, []);

  const discardModalShow = (value) => {
    setIsDiscardModal(true);
  };

  const discardModalClose = () => {
    setIsDiscardModal(false);
  };

  const discardModalConfirm = () => {
    setIsDiscardModal(false);
    let jobCardId =
      solutionId == 1 || solutionId == 2
        ? jobCardDetailsList[jobIndex].id
        : jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0].id;
    let solutionState =
      solutionId == 1 || solutionId == 3 ? "solution_1" : "solution_2";
    putSheetSolutionStatus(jobCardId, solutionState, "reject")
      .then((response) => {
        // !response.error && setReFetch(true);
        if (!response.error) {
          let detailsList = jobCardDetailsList;
          if (solutionId == 1 || solutionId == 2) {
            detailsList[jobIndex].jobcard[solutionState].data.status = "reject";
          } else {
            detailsList[jobIndex].newlyCreatedJobCardsDetails[0].jobcard[
              solutionState
            ].data.status = "reject";
          }
          setJobCardDetailsList(detailsList);
          setRerendering(!rerendering);
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };

  // Accepting solution

  const acceptModalShow = (value) => {
    setIsAcceptModal(true);
  };

  const acceptModalClose = () => {
    setIsAcceptModal(false);
  };
  const acceptModalConfirm = () => {
    setIsAcceptModal(false);
    let jobCardId =
      solutionId == 1 || solutionId == 2
        ? jobCardDetailsList[jobIndex].id
        : jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails[0].id;
    let groupId =
      solutionId == 1 || solutionId == 2
        ? jobCardDetailsList[jobIndex].jobcard.group.group_id
        : jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails[0].jobcard
          .group.group_id;
    console.log(groupId);

    setAcceptedJCGrpCode([...acceptedJCGrpCode, groupId]);
    let solutionState =
      solutionId == 1 || solutionId == 3 ? "solution_1" : "solution_2";
    let rejectedSolution =
      solutionId == 1 || solutionId == 3 ? "solution_2" : "solution_1";

    putSheetSolutionStatus(jobCardId, solutionState, "accept")
      .then((response) => {
        // !response.error && setReFetch(true);
        if (!response.error) {
          let detailsList = jobCardDetailsList;
          detailsList[jobIndex].jc_code = getJCCode(response?.data?.jobcard_code);
          if (solutionId == 1 || solutionId == 2) {
            detailsList[jobIndex].state = "pending";
            detailsList[jobIndex].jobcard[solutionState].data.status = "accept";
            detailsList[jobIndex].jobcard[rejectedSolution].data.status = "reject";
            if (detailsList[jobIndex].newlyCreatedJobCardsDetails?.length) {
              detailsList[jobIndex].newlyCreatedJobCardsDetails[0].jobcard[
                solutionState
              ].data.status = "reject";
              detailsList[jobIndex].newlyCreatedJobCardsDetails[0].jobcard[
                rejectedSolution
              ].data.status = "reject";
            }
          } else {
            detailsList[jobIndex].newlyCreatedJobCardsDetails[0].state =
              "pending";
            detailsList[jobIndex].jobcard[solutionState].data.status = "reject";
            detailsList[jobIndex].jobcard[rejectedSolution].data.status = "reject";
            detailsList[jobIndex].newlyCreatedJobCardsDetails[0].jobcard[
              solutionState
            ].data.status = "accept";
            detailsList[jobIndex].newlyCreatedJobCardsDetails[0].jobcard[
              rejectedSolution
            ].data.status = "reject";
          }
          setRenderKey(true);
          setJobCardDetailsList(detailsList);
          setRerendering(!rerendering);
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };

  const showViewDrawer = (value, record) => {
    setSelectedOrderNo(value);
    setSelectedOrder(record)
    setViewOrder(true);
  };

  const closeViewDrawer = () => {
    setViewOrder(false);
  };

  const getJobCardsListDetails = (
    jobcardIds,
    parentJobCardId = 0,
    uuid = "",
    isNewSolutionRequest = false
  ) => {
        let newsolcnt = false;
        let shouldActivateNewSolutionTab = false;
        let mergedJobCardIndex = -1;
    return getJobCardsDetails({ jobcards: jobcardIds })
      .then((response) => {
        if (!isNewSolutionRequest) {
          setJobCardDetailsList(response);
        } else {
          newsolcnt = true;
          let detailsList = [...jobCardDetailsList];
          let filteredJobCardIndex = detailsList.findIndex(function (
            jobCardDetails
          ) {
            return jobCardDetails.uuid == uuid;
          });
          if (filteredJobCardIndex === -1 && parentJobCardId) {
            filteredJobCardIndex = detailsList.findIndex(function (jobCardDetails) {
              return jobCardDetails.id == parentJobCardId;
            });
          }
          if (filteredJobCardIndex !== -1) {
            mergedJobCardIndex = filteredJobCardIndex;
            detailsList[filteredJobCardIndex] = {
              ...detailsList[filteredJobCardIndex],
              newlyCreatedJobCardsDetails: response,
            };
            shouldActivateNewSolutionTab = detailsList[filteredJobCardIndex]?.id == currentActiveJC.current;
            setJobCardDetailsList(detailsList);
            setShowAimation((prev) => ({
              ...prev,
              [filteredJobCardIndex]: false,
            }));
            setCreateNewSolutionClicked((prevState) =>
              prevState.index === filteredJobCardIndex
                ? { isClicked: false, index: -1 }
                : prevState
            );
            setRerendering((prev) => !prev);
          } else {
            console.error(`No matching job card found for uuid: ${uuid}`);
          }



          // setSolId("3");
          // setSolutionId("3");
        }
        // stockMachineValue['min_deckle_length'] = response[0].jobcard.group.machines[0].deckle_length_lb;
        // stockMachineValue['max_deckle_length'] = response[0].jobcard.group.machines[0].deckle_length_ub;
        // stockMachineValue['maximum_cutters'] = response[0].jobcard.group.machines[0].original_cutters;
        // stockMachineValue['effective_deckle_length'] = toFixedValue(parseFloat(response[0].jobcard.group.machines[0].effective_deckle_length) * CoversionFactorUnitsToCM[response[0].jobcard.group.machines[0].units.effective_deckle_length] * CoversionFactorCMToUnits[response[0].jobcard.group.machines[0].units.deckle_length_ub], 3);
        // stockMachineValue['left_edge_trim'] = response[0].jobcard.group.machines[0].left_edge_trim;
        // stockMachineValue['right_edge_trim'] = response[0].jobcard.group.machines[0].right_edge_trim;
        // stockMachineValue['units'] = response[0].jobcard.group.machines[0].units;
        // stockMachineValue['min_weight_per_partition'] = location.state.minWeight;
        // stockMachineValue['partitionWeightUnit'] = location.state.partitionWeightUnit;
        const stockTargetIndex =
          isNewSolutionRequest && mergedJobCardIndex !== -1
            ? mergedJobCardIndex
            : jobIndex;
        let stockMachineValue = formValuesForStock?.[stockTargetIndex];
        const cutterMachine = response[0]?.jobcard?.group?.machines[0];
        if (cutterMachine) {
          const {
            deckle_length_lb,
            deckle_length_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            units,
            machine_type,
            machine_code,
          } = cutterMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_length_ub];

          const minDeckleLength = deckle_length_lb;
          const maxDeckleLength =
            deckle_length_ub +
            (left_edge_trim + right_edge_trim) *
            rightEdgeTrimConversionFactor *
            deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length: minDeckleLength,
            max_deckle_length: deckle_length_ub,
            maximum_cutters: original_cutters,
            effective_deckle_length: effective_deckle_length,
            left_edge_trim: left_edge_trim,
            right_edge_trim: right_edge_trim,
            units: units,
            min_weight_per_partition: location.state.minWeight,
            partitionWeightUnit: location.state.partitionWeightUnit
          };
        }
        setFormValuesForStock((prev) => ({ ...prev, [stockTargetIndex]: stockMachineValue }));
      })
      .catch((error) => console.log(error)).finally(() => {
        newsolcnt && shouldActivateNewSolutionTab && setSolId("3");
        newsolcnt && shouldActivateNewSolutionTab && setSolutionId("3");
      });
  };

  const fetchOrders = async (solutionType, jobcard, solutionId) => {
    const solution =
      solutionId == 1
        ? "solution_1"
        : solutionId == 2
          ? "solution_2"
          : solutionId == 3
            ? "solution_1"
            : solutionId == 4
              ? "solution_2"
              : "";
    if (solutionType == "current_solution") {
      const setList =
        solutionId == 1
          ? setOrderDetailsList1
          : solutionId == 2
            ? setOrderDetailsList2
            : setFailedJobOrders;

      if (!solutionId) {
        setOrderDetailsList1();
        setOrderDetailsList2();
      }
      if (solutionId) {
        let sizeFulfillmentList1 = jobcard[solution].data.sizes.map(
          (size, index) => {
            return {
              key: index + 1,
              type: "Order",
              size: `${size.breadth} X ${size.length} ${(lengthUnit[size.units?.length].displayName).toUpperCase()}`,
              plannedReels: size.sheet_requirement,
              plannedWeight: size.weight_requirement.toFixed(3) + " " + capitalize(weightUnit[size.units?.weight_requirement].displayName),
              fulflilledReels: size.fulfilled_sheet,
              fulflilledWeight: size.fulfilled_weight.toFixed(3) + " " + capitalize(weightUnit[size.units?.fulfilled_weight].displayName),
              unFulflilledReels: size.unfulfilled_sheet,
              unFulflilledWeight: size.unfulfilled_weight.toFixed(3) + " " + capitalize(weightUnit[size.units?.unfulfilled_weight].displayName),
            };
          }
        );

        if (solution == "solution_1") {
          setSizeFulfillmentSolution1(sizeFulfillmentList1);
        } else setSizeFulfillmentSolution2(sizeFulfillmentList1);
      }
      const ordersList = solution
        ? jobcard[solution]?.data.orders
          ?.filter((order) => {
            return order.type.toLowerCase() == "order";
          })
          .map((item) => item.order_id)
        : jobcard.group.orders.map((item) => item.order_id);
      ordersList &&
        getOrdersList(ordersList)
          .then((response) => {
            setList(
              response.data.map((item, index) => {
                const orderData = solution
                  ? jobcard[solution]?.data.orders.filter(
                    (order) => order.order_id == item.number
                  )[0]
                  : jobcard.group.orders.filter(
                    (order) => order.order_id == item.number
                  )[0];
                //console.log(orderData);
                return {
                  key: index + 1,
                  pono: `${item.po}`,
                  category: item?.category,
                  overfulfillmentPercentage: `${(((orderData.fulfilled_rquirement / orderData.requirement) - 1) * 100).toFixed(2)}%`,
                  sono: item?.so,
                  orderno: `${item.number}`,
                  grain: item.grain == 'short' ? 'Short' : 'Long',
                  type: `Order`,
                  productspec: item.product_spec,
                  customercode: item.customer,
                  customername: item.customer_name,
                  customer_alias: item.customer_alias,
                  size: `${item.width}${item.length ? ` x ${item.length}` : ""
                    } ${(lengthUnit[item.units?.width].displayName).toUpperCase()}`,
                  plannedReels: orderData.requirement,
                  plannedWeight: solution
                    ? orderData.requirement_weight?.toFixed(3) + " " + capitalize(weightUnit[orderData.units?.requirement_weight].displayName)
                    : item.planned_weight?.toFixed(3) + " " + capitalize(weightUnit[item.units?.planned_weight].displayName),
                  fulflilledReels: orderData.fulfilled_rquirement,
                  fulflilledWeight:
                    orderData.fulfilled_rquirement_weight?.toFixed(3) + " " + (orderData.units?.fulfilled_rquirement_weight ? capitalize(weightUnit[orderData.units?.fulfilled_rquirement_weight].displayName) : ''),
                  unFulflilledReels: solution
                    ? orderData.unfulfilled_rquirement
                    : orderData.requirement,
                  unFulflilledWeight: solution
                    ? orderData.unfulfilled_rquirement_weight?.toFixed(3) + " " + capitalize(weightUnit[orderData.units?.unfulfilled_rquirement_weight].displayName)
                    : item.planned_weight?.toFixed(3) + " " + capitalize(weightUnit[item.units?.planned_weight].displayName),
                  priority: item.forced,
                  deliverydate: item.category === 'so' ? "-" : moment(item.delivery_date).format("DD MMM YYYY"),
                  remarks: item.remarks,
                  customer_alias: item.customer_alias,
                };
              })
            );
          })
          .catch((error) => console.log(error));
    }
    if (solutionType == "new_solution") {
      if (solutionId && jobcard) {
        let sizeFulfillmentList1 = jobcard[solution]?.data.sizes.map(
          (size, index) => {
            return {
              key: index + 1,
              type: "Order",
              size: `${size.breadth} X ${size.length} ${(lengthUnit[size.units?.length].displayName).toUpperCase()}`,
              plannedReels: size.sheet_requirement,
              plannedWeight: size.weight_requirement.toFixed(3) + " " + capitalize(weightUnit[size.units?.weight_requirement].displayName),
              fulflilledReels: size.fulfilled_sheet,
              fulflilledWeight: size.fulfilled_weight.toFixed(3) + " " + capitalize(weightUnit[size.units?.fulfilled_weight].displayName),
              unFulflilledReels: size.unfulfilled_sheet,
              unFulflilledWeight: size.unfulfilled_weight.toFixed(3) + " " + capitalize(weightUnit[size.units?.unfulfilled_weight].displayName),
            };
          }
        );

        if (solution == "solution_1") {
          setSizeFulfillmentNewSolution1(sizeFulfillmentList1);
        } else setSizeFulfillmentNewSolution2(sizeFulfillmentList1);
      }

      let ordersListInNewSolution = [];
      let ordersList;
      ordersList = solution && jobcard
        ? jobcard[solution]?.data.orders
          ?.filter((order) => {
            return order.type.toLowerCase() == "order";
          })
          .map((item) => item.order_id)
        : jobcard?.group.orders
          ?.filter((order) => {
            return order.item_type.toLowerCase() == "order";
          })
          .map((item) => item.order_id)
      ordersList &&
        getOrdersList(ordersList)
          .then((response) => {
            ordersListInNewSolution = response.data.map((item, index) => {
              const orderData = solution && jobcard
                ? jobcard[solution]?.data.orders.filter(
                  (order) => order.order_id == item.number
                )[0]
                : jobcard.group.orders.filter(
                  (order) => order.order_id == item.number
                )[0];
              //console.log(orderData);
              return {
                key: index + 1,
                pono: `${item.po}`,
                overfulfillmentPercentage: `${(((orderData.fulfilled_rquirement / orderData.requirement) - 1) * 100).toFixed(2)}%`,
                category: item?.category,
                sono: item?.so,
                orderno: `${item.number}`,
                grain: item.grain == 'short' ? 'Short' : 'Long',
                type: `Order`,
                productspec: item.product_spec,
                customercode: item.customer,
                customername: item.customer_name,
                size: `${item.width}${item.length ? ` x ${item.length}` : ""
                  } ${(lengthUnit[item.units?.width].displayName).toUpperCase()}`,
                plannedReels: orderData.requirement,
                plannedWeight: solution
                  ? orderData.requirement_weight?.toFixed(3) + " " + capitalize(weightUnit[orderData.units?.requirement_weight].displayName)
                  : item.planned_weight?.toFixed(3) + " " + capitalize(weightUnit[item.units?.planned_weight].displayName),
                fulflilledReels: orderData.fulfilled_rquirement,
                fulflilledWeight:
                  orderData.fulfilled_rquirement_weight?.toFixed(3) + " " + (orderData.units?.fulfilled_rquirement_weight ? capitalize(weightUnit[orderData.units?.fulfilled_rquirement_weight].displayName) : ''),
                unFulflilledReels: solution
                  ? orderData.unfulfilled_rquirement
                  : orderData.requirement,
                unFulflilledWeight: solution
                  ? orderData.unfulfilled_rquirement_weight?.toFixed(3) + " " + capitalize(weightUnit[orderData.units?.unfulfilled_rquirement_weight].displayName)
                  : item.planned_weight?.toFixed(3) + " " + capitalize(weightUnit[item.units?.planned_weight].displayName),
                priority: item.forced,
                deliverydate: item.category === 'so' ? "-" : moment(item.delivery_date).format("DD MMM YYYY"),
                remarks: item.remarks,
                customer_alias: item.customer_alias,
              };
            });

            const stockSizesList = solution && jobcard
              ? jobcard[solution]?.data.orders
                ?.filter((order) => {
                  return (
                    order.type == "stock" &&
                    order.creation_type != "dynamic" &&
                    order.creation_type != "required"
                  );
                })
                .map((item) => item.order_id)
              : jobcard?.group.orders
                ?.filter((order) => {
                  return (
                    order.type == "stock" &&
                    order.creation_type != "dynamic" &&
                    order.creation_type != "required"
                  );
                })
                .map((item) => item.order_id)
            stockSizesList &&
              getStockSizesDetailsByIds({ stock_sizes: stockSizesList })
                .then((response) => {
                  let sizesList = response.data.map((item, index) => {
                    const orderData = solution && jobcard
                      ? jobcard[solution].data.orders.filter(
                        (order) => order.order_id == item.id
                      )[0]
                      : jobcard.group.orders.filter(
                        (order) => order.order_id == item.id
                      )[0];
                    //console.log(orderData);
                    return {
                      key: index + 1,
                      pono: "-",
                      overfulfillmentPercentage: `${(((orderData.fulfilled_rquirement / orderData.requirement) - 1) * 100).toFixed(2)}%`,
                      orderno: `${item.id}`,
                      type: "Stock",
                      productspec: item.product_spec,
                      customercode: "-",
                      customername: "-",
                      size: `${item.width}${item.length ? ` x ${item.length}` : ""
                        } ${(lengthUnit[item.units?.width].displayName).toUpperCase()}`,
                      plannedReels: "-",
                      plannedWeight: "-",
                      fulflilledReels: orderData.fulfilled_rquirement,
                      fulflilledWeight:
                        orderData.fulfilled_rquirement_weight?.toFixed(3) + " " + (orderData.units?.fulfilled_rquirement_weight ? capitalize(weightUnit[orderData.units?.fulfilled_rquirement_weight].displayName) : ''),
                      unFulflilledReels: "-",
                      unFulflilledWeight: "-",
                      priority: false,
                      deliverydate: "-",
                      remarks: "-",
                    };
                  });

                  let dynamicStockInfo = [];

                  let dynamicStock = jobcard[solution].data.orders?.filter(
                    (order) => {
                      return (
                        order.creation_type == "dynamic" ||
                        order.creation_type == "required"
                      );
                    }
                  );
                  if (dynamicStock.length) {
                    dynamicStockInfo = [
                      ...dynamicStock?.map((item, index) => {
                        // console.log(orderData);
                        return {
                          key: index + 1,
                          pono: "-",
                          overfulfillmentPercentage: `${(((item.fulfilled_rquirement / item.requirement) - 1) * 100).toFixed(2)}%`,
                          orderno: `-`,
                          type: "Stock",
                          productspec: jobcard.group.product.product_spec,
                          customercode: "-",
                          customername: "-",
                          size: `${item.size} ${item.units?.size
                            ? lengthUnit[
                              item.units?.size
                            ]?.displayName?.toUpperCase()
                            : "CM"
                            }`,
                          plannedReels: "-",
                          plannedWeight: "-",
                          fulflilledReels: item.fulfilled,
                          fulflilledWeight:
                            item.fulfilled_weight?.toFixed(3) +
                            " " +
                            (item.units?.fulfilled_weight
                              ? capitalize(
                                weightUnit[item.units?.fulfilled_weight]
                                  ?.displayName
                              )
                              : ""),
                          unFulflilledReels: "-",
                          unFulflilledWeight: "-",
                          priority: false,
                          deliverydate: "-",
                          remarks: "-",
                          consignee: "-",
                          reelSpecification: item?.diameter_fulfillment?.map(
                            (diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[item.units?.fulfilled_weight]
                                  ?.displayName
                              );
                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                            }
                          ),
                        };
                      }),
                    ];
                  }

                  solutionId === 3
                    ? setStockSizeDetailsList1([
                      ...ordersListInNewSolution,
                      ...sizesList,
                      ...dynamicStockInfo,
                    ])
                    : setStockSizeDetailsList2([
                      ...ordersListInNewSolution,
                      ...sizesList,
                      ...dynamicStockInfo,
                    ]);
                  // setTotalFulfilledOrders(
                  //   [
                  //     ...ordersListInNewSolution,
                  //     ...sizesList,
                  //     ...dynamicStockInfo,
                  //   ].length
                  // );
                })
                .catch((error) => console.log(error));
          })
          .catch((error) => console.log(error));
    }
    let tempOrdersArray = [];
    jobcard?.group?.orders?.map((order) => {
      tempOrdersArray.push(order.order_id);
    });
    if (selectedJobCardId) {
      setOrdersIdListByJobCard((prev) => {
        if (prev[selectedJobCardId] !== undefined) {
          return prev;
        }
        return {
          ...prev,
          [selectedJobCardId]: tempOrdersArray,
        };
      });
      const currentOrdersForJobCard =
        ordersIdListByJobCard?.[selectedJobCardId] ?? tempOrdersArray;
      setOrderIdList([...(currentOrdersForJobCard || [])]);
    } else {
      setOrderIdList([...tempOrdersArray]);
    }
  };

  const onClickCreateNewSolution = (index) => {
    const selectedJobCard = jobCardDetailsList?.[index];
    const selectedJobCardId = selectedJobCard?.id;
    const isPendingNewSolution =
      !!showAimation?.[index] ||
      pendingJobCardsForNewSol?.some(
        (pendingJobCard) =>
          pendingJobCard?.uuid === selectedJobCard?.uuid ||
          pendingJobCard?.jobCardId === selectedJobCardId
      );

    if (isPendingNewSolution) {
      setJobIndex(index);
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
      return;
    }

    const nextOrders =
      ordersIdListByJobCard?.[selectedJobCardId] ??
      selectedJobCard?.jobcard?.group?.orders?.map((order) => order.order_id) ??
      [];

    setJobIndex(index);
    calcStockValues(index);
    setStockSizes(stockSizesByJobCard?.[selectedJobCardId] || []);
    setOrderIdList(nextOrders);
    let data = jobcardIdsWithCode[index];
    setActiveJC(data?.jc_code);
    currentActiveJC.current = data?.id;
    setCreateNewSolutionClicked({ isClicked: true, index: index });
    // history("../create-new-job-cards");
    // history("../create-new-job-cards", {
    //   state: {
    //     jobCards: response.data,
    //     // failed: response.data.failed_groups,
    //     // total_groups: response.data.total_groups
    //   },
    // });
  };
  const calcStockValues = (index) => {
    if (formValuesForStock?.[index]) return;
    const cutterMachine = jobCardDetailsList[index]?.jobcard?.group?.machines[0];
    let stockMachineValue = { ...formValuesForStock?.[index] };
    if (cutterMachine) {
      const {
        deckle_length_lb,
        deckle_length_ub,
        left_edge_trim,
        right_edge_trim,
        original_cutters,
        effective_deckle_length,
        units,
        machine_type,
        machine_code,
      } = cutterMachine;

      const rightEdgeTrimConversionFactor =
        CoversionFactorUnitsToCM[units.right_edge_trim];
      const deckleSizeUbConversionFactor =
        CoversionFactorCMToUnits[units.deckle_length_ub];

      const minDeckleLength = deckle_length_lb;
      const maxDeckleLength =
        deckle_length_ub +
        (left_edge_trim + right_edge_trim) *
        rightEdgeTrimConversionFactor *
        deckleSizeUbConversionFactor;

      stockMachineValue = {
        ...stockMachineValue,
        min_deckle_length: minDeckleLength,
        max_deckle_length: deckle_length_ub,
        maximum_cutters: original_cutters,
        effective_deckle_length: effective_deckle_length,
        left_edge_trim: left_edge_trim,
        right_edge_trim: right_edge_trim,
        units: units,
        min_weight_per_partition: location.state.minWeight,
        partitionWeightUnit: location.state.partitionWeightUnit
      };
    }
    setFormValuesForStock({ ...formValuesForStock, [index]: stockMachineValue });
  }
  const callbackKey = (key) => {
    setActiveTab('1');
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    let ind = jobCardDetailsList.findIndex(ele => ele.id == key);
    setSolId("1");
    setSolutionId("1");
    setJobIndex(parseInt(ind));
    if (!jobCardDetailsList[parseInt(ind)])
      failedGroups.filter((item, index) => {
        if (item == parseInt(ind)) {
          setFailedjobIndex(index);
          return index;
        }
      });
    const nextJcId = jobCardDetailsList?.[parseInt(ind)]?.id;
    const nextOrders =
      ordersIdListByJobCard?.[nextJcId] ??
      jobCardDetailsList?.[parseInt(ind)]?.jobcard?.group?.orders?.map(
        (order) => order.order_id
      ) ??
      [];
    setStockSizes(stockSizesByJobCard?.[nextJcId] || []);
    setOrderIdList(nextOrders);
    calcStockValues(parseInt(ind))
    setCreateNewSolutionClicked((prevState) => ({
      ...prevState,
      isClicked: false,
    }));
    let data = jobcardIdsWithCode[ind];
    setActiveJC(data?.jc_code);
    currentActiveJC.current = data?.id;
  };

  useEffect(() => {
    const currentJobDetails = jobCardDetailsList?.[jobIndex];
    if (!currentJobDetails) return;
    const hasNewSolutionTabs =
      !!currentJobDetails?.newlyCreatedJobCardsDetails &&
      !!currentJobDetails?.newlyCreatedJobCardsDetails?.length;
    if (!hasNewSolutionTabs && (solId === "3" || solId === "4" || solutionId === "3" || solutionId === "4")) {
      const fallbackSolutionId =
        solId === "4" || solutionId === "4"
          ? "2"
          : "1";
      setSolId(fallbackSolutionId);
      setSolutionId(fallbackSolutionId);
    }
  }, [jobCardDetailsList, jobIndex, solId, solutionId]);

  useEffect(() => {
    console.log('stopCancellApi', stopCancellApi.current, 'stopCancelled', stopCancelled);
    return () => {
      console.log('stopCancellApi', stopCancellApi.current, 'stopCancelled', stopCancelled);
      if (stopCancelled || stopCancellApi.current) return;
      cancelJobCard();
      stopCancellApi.current = false;
      setStopCancelled(false);
      handleResetAll();
    };
  }, []);
  useEffect(() => {
    if (reFetch && jobcardIds.length) {
      getJobCardsListDetails(jobcardIds);
      setReFetch(false);
    }
    // return () => {
    //   if(!isGoBack) {
    //     setFormObject(paperMachineFormValues);
    //   }
    // };
  }, [reFetch]);

  useEffect(() => {
    if ((jobCardDetailsList && jobCardDetailsList.length !== 0) || (failedJobs && failedJobs.length)) {
      if (jobCardDetailsList[jobIndex]) {
        if (jobCardDetailsList[jobIndex].jobcard.solution_1.data) {
          fetchOrders(
            "current_solution",
            jobCardDetailsList[jobIndex].jobcard,
            1
          );
        } else {
          fetchOrders(
            "current_solution",
            jobCardDetailsList[jobIndex].jobcard,
            1
          );
        }
        if (jobCardDetailsList[jobIndex].jobcard.solution_2.data.exception) {
          fetchOrders("current_solution", jobCardDetailsList[jobIndex].jobcard);
        } else {
          fetchOrders(
            "current_solution",
            jobCardDetailsList[jobIndex].jobcard,
            2
          );
        }

        if (jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails) {
          if (
            jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0].jobcard
              ?.solution_1.data.exception
          ) {
            fetchOrders(
              "new_solution",
              jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0]
                .jobcard
            );
          } else {
            fetchOrders(
              "new_solution",
              jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0]
                .jobcard,
              3
            );
          }
          if (
            jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0].jobcard
              ?.solution_2.data.exception
          ) {
            fetchOrders(
              "new_solution",
              jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0]
                .jobcard
            );
          } else {
            fetchOrders(
              "new_solution",
              jobCardDetailsList[jobIndex].newlyCreatedJobCardsDetails[0]
                .jobcard,
              4
            );
          }
        }
      } else {
        fetchOrders("current_solution", failedJobs[failedjobIndex]);
      }
    }
  }, [jobCardDetailsList, jobIndex, failedjobIndex, rerendering, failedJobs]);

  useEffect(() => {
    if (failedGroups.length) {
      setTimeout(() => {
        getFailedGrps();
      }, 1000);
      // setFetchFailed(false);
    }
  }, [failedGroups]);

  useEffect(() => {
    if (jobcardIds?.length && jobCardDetailsList?.length) {
      let jcData = [];
      let jcObj = {};
      jobCardDetailsList.map((item, index) => {
        jcObj = {};
        jcObj["id"] = item?.id;
        if (item?.isFailedJobcard) {
          if (item?.newlyCreatedJobCardsDetails?.length && item?.isSuccessful && item?.newlyCreatedJobCardsDetails[0]?.state == "pending") {
            jcObj["jc_code"] = item?.jc_code;
          } else {
            jcObj["jc_code"] = (index + 1);
          }
        } else {
          if (item?.state == "pending") {
            jcObj["jc_code"] = item?.jc_code;
          } else {
            jcObj["jc_code"] = (index + 1);
          }
        }
        jcData.push(jcObj);
      });
      console.log(jcData);
      setJobcardIdsWithCode(jcData);
      if (currentActiveJC.current) {
        let currentJCCode = jcData.filter((ele) => ele.id == currentActiveJC.current)
        currentActiveJC.current = currentJCCode[0]?.id;
        setActiveJC(currentJCCode[0]?.jc_code);
      } else {
        let selectedData;
        if (jobcardIds.length) {
          selectedData = jcData?.filter((item) => item.id == jobcardIds[0]);
        } else {
          selectedData = jcData?.filter((item) => item.id == failedGroups[0])
        }
        currentActiveJC.current = selectedData[0]?.id;
        setActiveJC(selectedData[0]?.jc_code);
      }
      // setActiveJC(jcData[0]?.jc_code);
      setRenderKey(false);
    }
  }, [jobcardIds, jobCardDetailsList, renderKey]);

  const getFailedGrps = () => {
    getFailedGroups({ failed_groups: failedGroups })
      .then((response) => {
        setFailedJobs(response);
      })
      .catch((error) => console.log("Error Message in failed jobcards", error));
  };

  const orderFulfillmentColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "9%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono);

        return (
          <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
            {value
              ?.match(/.{1,15}/g)
              ?.map((chunk, index) => (
                <span key={index}>
                  {chunk}
                  <br />
                </span>
              ))}
          </span>
        );
      }

    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },

    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: "9%",
    },

    {
      title: "Planned Weight",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Weight",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Overfulfilment %",
      dataIndex: "overfulfillmentPercentage",
      width: "10%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "9%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const unfulfilledColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "9%",
      fixed: "left",
      align: "center", render: (text, record) => (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
          {
            `${record.category === "so" ? toHandlePOName(record.sono) : toHandlePOName(record.pono)}`
              .match(/.{1,15}/g)
              ?.map((chunk, index) => (
                <span key={index}>
                  {chunk}
                  <br />
                </span>
              ))
          }
        </span>
      )
    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "10%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "6%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "9%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || '-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: "9%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Unfulfilled Quantity",
      dataIndex: "unFulflilledReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Unfulfilled Weight",
      dataIndex: "unFulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "9%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type == "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const sizeFulfillmentColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "7%",
    //   fixed: "left",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "Fulfilled Weight",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledReels",
      width: "8%",
      // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    },
    {
      title: "UnFulfilled/(Overfulfilled) Weight",
      dataIndex: "unFulflilledWeight",
      width: "10%",
      render: (text, record) => {
        const parsedValue = parseFloat(text?.split(" ")[0]);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue} {text?.split(" ")[1]})
          </div>
        ) : (
          text
        );
      },
    },
    {
      title: "Unfulfilled/(Overfulfilled) Quantity",
      dataIndex: "unFulflilledReels",
      width: "8%",
      render: (text, record) => {
        const parsedValue = parseFloat(text);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue})
          </div>
        ) : (
          text
        );
      },
    },
  ];

  const onClickCreateSolution = async (e, jobCardId, uuid, ind) => {
    setActiveTab('1');
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    // setShowAimation(true);
    setShowAimation((prev) => {
      return { ...prev, [ind]: true };
    });
    if (jobCardDetailsList?.[ind]?.newlyCreatedJobCardsDetails) {
      setJobCardDetailsList((prev) => {
        const nextJobCardDetailsList = [...prev];
        nextJobCardDetailsList[ind] = {
          ...nextJobCardDetailsList[ind],
          newlyCreatedJobCardsDetails: undefined,
        };
        return nextJobCardDetailsList;
      });
    }
    let sizes = [];
    setCreateNewSolutionFormValuesByJobCard((prev) => ({
      ...prev,
      [jobCardId]: e,
    }));
    if (e.selectedSizes.length > 0) {
      e.selectedSizes.forEach((size) => {
        // let sizeObject = {
        //   id: size.stockSizeId,
        //   allowed_quantity: parseFloat(size.allowedQuantity),
        //   sheets: size.sheets,
        //   planned_weight: parseFloat( size.plannedWeight),
        //   length: size.length,
        //   breadth: size.width,
        //   mixed_grain: false,
        //   rotation: size.rotated,
        //   units : size.units
        // };
        let sizeObject = {
          type: "sheet",
          id: size.stockSizeId,
          allowed_quantity: parseFloat(size.allowedQuantity),
          sheets: size.sheets,
          planned_weight: parseFloat(size.plannedWeight),
          rotation: size.rotated,
          grain: size.grain,
          length: parseFloat(size.length),
          breadth: parseFloat(size.width),
          mixed_grain: false,
          ...(size.creation_type === "required" && {
            weight_lb: parseFloat(size.weight_lb),
            weight_ub: parseFloat(size.weight_ub),
            requirement_lb: parseInt(size.requirement_lb),
            requirement_ub: parseInt(size.requirement_ub),
            priority_stock: size.priority_stock,
          }),
          units: size.units,
          creation_type: size.creation_type,

        }
        sizes.push(sizeObject);
      });
    }

    let updatedFormValues = {};
    updatedFormValues["max_deckle_length"] = e.maxDeckleLength
      ? parseFloat(e.maxDeckleLength)
      : formValuesForStock?.[ind]?.max_deckle_length;
    updatedFormValues["min_deckle_length"] = e.minDeckleLength
      ? parseFloat(e.minDeckleLength)
      : formValuesForStock?.[ind]?.min_deckle_length;
    updatedFormValues["left_edge_trim"] = e.minWidth
      ? parseFloat(e.minWidth)
      : formValuesForStock?.[ind]?.left_edge_trim;
    updatedFormValues["right_edge_trim"] = e.maxWidth
      ? parseFloat(e.maxWidth)
      : formValuesForStock?.[ind]?.right_edge_trim;
    updatedFormValues["maximum_cutters"] = e.cutters
      ? parseFloat(e.cutters)
      : formValuesForStock?.[ind]?.maximum_cutters;
    updatedFormValues["effective_deckle_length"] = e.effectiveDeckleLength
      ? parseFloat(e.effectiveDeckleLength)
      : "";
    updatedFormValues['units'] = {
      max_deckle_length: e.deckleLengthUnit,
      min_deckle_length: e.deckleLengthUnit,
      left_edge_trim: e.widthUnit,
      right_edge_trim: e.widthUnit,
      effective_deckle_length: e.deckleLengthUnit,
      deckle_length_ub: e.deckleLengthUnit
    }

    updatedFormValues['min_weight_per_partition'] = e.min_weight_per_partition
      ? parseFloat(e.min_weight_per_partition) : parseFloat(formValuesForStock?.[ind]?.min_weight_per_partition);
    updatedFormValues.units['min_weight_per_partition'] = e.partitionWeightUnit;
    updatedFormValues['partitionWeightUnit'] = e.partitionWeightUnit;


    setFormValuesForStock({ ...formValuesForStock, [ind]: updatedFormValues });
    let request = {
      jobcard: location?.state?.parentJCid || jobCardId,
      run_type: "selected_sizes",
      machine_selection_data: {
        maximum_deckle_size: e.maxDeckleLength
          ? parseFloat(e.maxDeckleLength)
          : formValuesForStock?.[ind]?.max_deckle_length,
        minimum_deckle_size: e.minDeckleLength
          ? parseFloat(e.minDeckleLength)
          : formValuesForStock?.[ind]?.min_deckle_length,
        left_edge_trim: e.minWidth
          ? parseFloat(e.minWidth)
          : formValuesForStock?.[ind]?.left_edge_trim,
        right_edge_trim: e.maxWidth
          ? parseFloat(e.maxWidth)
          : formValuesForStock?.[ind]?.right_edge_trim,
        maximum_cutters: e.cutters
          ? parseFloat(e.cutters)
          : formValuesForStock?.[ind]?.maximum_cutters,
        effective_deckle_length: e.effectiveDeckleLength
          ? parseFloat(e.effectiveDeckleLength)
          : "",
        units: {
          minimum_deckle_size: e.deckleLengthUnit,
          maximum_deckle_size: e.deckleLengthUnit,
          left_edge_trim: e.widthUnit,
          right_edge_trim: e.widthUnit,
          effective_deckle_length: e.deckleLengthUnit
        },
      },
      sizes: sizes,
    };


    request.machine_selection_data['min_weight_per_partition'] = e.min_weight_per_partition
      ? parseFloat(e.min_weight_per_partition) : parseFloat(formValuesForStock?.[ind]?.min_weight_per_partition);
    request.machine_selection_data.units['min_weight_per_partition'] = e.partitionWeightUnit


    try {

      let jobCard = cutter.type == 'simplex' ? await createNewSheetSolution(request) : await createNewDuplexSolution(request);
      setCreateNewSolutionClicked({ isClicked: true, index: ind });
      // Add to pending array to start polling
      setPendingJobCardsForNewSol((prev) => [
        ...prev,
        {
          uuid: uuid,
          jobCardId: jobCardId,
          requestJobcard: request.jobcard,
          type: cutter.type,
        },
      ]);
      // setShowAimation(false);
    }
    catch (error) {
      let updatedFormValues = {};
      updatedFormValues["max_deckle_length"] = e.maxDeckleLength
        ? parseFloat(e.maxDeckleLength)
        : formValuesForStock?.[ind]?.max_deckle_length;
      updatedFormValues["min_deckle_length"] = e.minDeckleLength
        ? parseFloat(e.minDeckleLength)
        : formValuesForStock?.[ind]?.min_deckle_length;
      updatedFormValues["left_edge_trim"] = e.minWidth
        ? parseFloat(e.minWidth)
        : formValuesForStock?.[ind]?.left_edge_trim;
      updatedFormValues["right_edge_trim"] = e.maxWidth
        ? parseFloat(e.maxWidth)
        : formValuesForStock?.[ind]?.right_edge_trim;
      updatedFormValues["maximum_cutters"] = e.cutters
        ? parseFloat(e.cutters)
        : formValuesForStock?.[ind]?.maximum_cutters;
      updatedFormValues["effective_deckle_length"] = e.effectiveDeckleLength
        ? parseFloat(e.effectiveDeckleLength)
        : "";
      updatedFormValues['units'] = {
        max_deckle_length: e.deckleLengthUnit,
        min_deckle_length: e.deckleLengthUnit,
        left_edge_trim: e.widthUnit,
        right_edge_trim: e.widthUnit,
        effective_deckle_length: e.deckleLengthUnit,
        deckle_length_ub: e.deckleLengthUnit
      }

      updatedFormValues['min_weight_per_partition'] = e.min_weight_per_partition
        ? parseFloat(e.min_weight_per_partition) : parseFloat(formValuesForStock?.[ind]?.min_weight_per_partition);
      updatedFormValues.units['min_weight_per_partition'] = e.partitionWeightUnit;
      updatedFormValues['partitionWeightUnit'] = e.partitionWeightUnit;

      setFormValuesForStock({ ...formValuesForStock, [ind]: updatedFormValues });

      let jobcardResp = [];

      let jobCard = await getAlgorithmCompletionStatus();
      //setCreateNewSolutionClicked({ isClicked: true, index: -1 });
      //getJobCardsListDetails([jobCard.data.failed_groups[0]], jobCardId, uuid);
      let response = await getFailedGroups({ failed_groups: jobCard.data.failed_groups })
      // setShowAimation(false);
      let detailsList = jobCardDetailsList;
      let filteredJobCardIndex = detailsList.findIndex(function (
        jobCardDetails
      ) {
        return jobCardDetails.uuid == uuid;
      });
      if (filteredJobCardIndex === -1 && jobCardId) {
        filteredJobCardIndex = detailsList.findIndex(function (jobCardDetails) {
          return jobCardDetails.id == jobCardId;
        });
      }

      let data = {
        orders: [],
        partitions: [],
        sizes: [],
      }

      let jobcardData = {
        created_at: response[0]?.created_at,
        uuid: response[0]?.uuid,
        id: response[0]?.id,
        user_id: response[0]?.user_id,
        updated_at: response[0]?.updated_at,
        jobcard: {
          group: response[0]?.group,
          solution_1: { data },
          solution_2: { data },
        },
      }
      jobcardResp.push(jobcardData);

      if (filteredJobCardIndex !== -1) {
        detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
          jobcardResp;
        setJobCardDetailsList(detailsList);
      } else {
        console.error(`No matching job card found for uuid: ${uuid}`);
      }
      setShowAimation((prev) => ({
        ...prev,
        [ind]: false,
      }));
      setCreateNewSolutionClicked((prevState) =>
        prevState.index === ind
          ? { isClicked: false, index: -1 }
          : prevState
      );
      setRerendering((prev) => !prev);
      if (currentActiveJC.current == jobCardId) {
        setSolId("3");
        setSolutionId("3");
      }

    } finally {
      setCreateNewSolutionClicked((prevState) =>
        prevState.index === ind
          ? { isClicked: false, index: -1 }
          : prevState
      );
    }
  };

  const setActiveKey = (activeKey) => {
    setSolutionId(activeKey);
    setSolId(activeKey);
  };

  const tabChange = (key) => setActiveTab(key);

  return (([jobCardDetailsList && jobCardDetailsList.length] || [failedJobs && failedJobs.length]) && unitData) ? (
    <RightLayoutContainer>
      <PageTitleComp>
        <PageHeader
          ghost={false}
          title="Deckle Match Results"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg noMargin"
              onClick={routeChange}
            >
              Go Back
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      {/* if failed groups are empty and total groups are not same as jobcards */}
      {failedGroups.length + jobcardIds.length != totalGroups && (
        <div className="failedProgress">
          <span className="failedJobMessage">
            {jobcardIds.length + failedGroups.length} out of {totalGroups} Job Cards are generated,
            &nbsp;{totalGroups - (jobcardIds.length + failedGroups.length)} job cards are still in
            process
          </span>
          <Progress
            percent={((jobcardIds.length + failedGroups.length) / totalGroups) * 100}
            showInfo={false}
          />
        </div>
      )}
      {/* if failed groups and jobcards are eaul to total passed groups ? */}
      {failedGroups.length + jobcardIds.length == totalGroups && (
        <div className="failedProgress">
          <span className="failedJobMessage">
            All {totalGroups} Job Cards are generated
          </span>
          <Progress
            percent={
              ((jobcardIds.length + failedGroups.length) / totalGroups) * 100
            }
            showInfo={false}
          />
        </div>
      )}
      <ResultWrap1>
        <DetailFields>
          {[jobCardDetailsList && jobCardDetailsList.length] || [failedJobs && failedJobs.length] ? (
            <Tabs
              // defaultActiveKey={0}
              defaultActiveKey={
                jobcardIds.length ? jobcardIds[0]?.toString() : failedGroups[0]?.toString()
              }
              tabPosition="left"
              className="leftPostTab"
              onChange={callbackKey}
              style={{ backgroundColor: "#faf9f8" }}
            >
              {jobCardDetailsList && jobCardDetailsList.length && jobCardDetailsList.map((job, index) => (
                <TabPane
                  // key={index}
                  key={job.id}
                  style={{
                    backgroundColor: "#ffffff",
                    borderLeft: "1px solid #ebebeb",
                  }}
                  tab={
                    <div className="deckleMatchIcon disabled">
                      <img
                        src={
                          job.jobcard.solution_1.data.status == "accept" ||
                            job.jobcard.solution_2.data.status == "accept" ||
                            (job.newlyCreatedJobCardsDetails &&
                              job.newlyCreatedJobCardsDetails.length &&
                              job.newlyCreatedJobCardsDetails[0].jobcard
                                ?.solution_1.data.status == "accept") ||
                            (job.newlyCreatedJobCardsDetails &&
                              job.newlyCreatedJobCardsDetails.length &&
                              job.newlyCreatedJobCardsDetails[0].jobcard
                                ?.solution_2.data.status == "accept")
                            ? alerttrue
                            : job.jobcard.solution_1.data.status == "reject" &&
                              job.jobcard.solution_2.data.status == "reject" &&
                              job.newlyCreatedJobCardsDetails &&
                              job.newlyCreatedJobCardsDetails.length &&
                              job.newlyCreatedJobCardsDetails[0].jobcard
                                ?.solution_1.data.status == "reject" &&
                              job.newlyCreatedJobCardsDetails &&
                              job.newlyCreatedJobCardsDetails.length &&
                              job.newlyCreatedJobCardsDetails[0].jobcard
                                ?.solution_2.data.status == "reject"
                              ? wrongIco
                              : job.jobcard.solution_1.data.exception ||
                                job.jobcard.solution_2.data.exception ||
                                (job.newlyCreatedJobCardsDetails &&
                                  job.newlyCreatedJobCardsDetails.length &&
                                  job.newlyCreatedJobCardsDetails[0].jobcard
                                    ?.solution_1.data.exception) ||
                                (job.newlyCreatedJobCardsDetails &&
                                  job.newlyCreatedJobCardsDetails.length &&
                                  job.newlyCreatedJobCardsDetails[0].jobcard
                                    ?.solution_2.data.exception)
                                ? warningjob
                                : vectorIco
                        }
                      />
                      {/* {job?.jc_code ? job?.jc_code : ("JC " + (index+1))} */}
                      {job?.jc_code ?
                        (job?.jc_code?.length > 20 ? (
                          <Tooltip placement="bottomLeft" title={job?.jc_code}>
                            {job?.jc_code?.slice(0, 21) + "..."}
                          </Tooltip>) : (
                          job?.jc_code
                        )) : (
                          "JC " + (index + 1)
                        )}
                    </div>
                  }
                >
                  {createNewSolutionClicked.isClicked &&
                    createNewSolutionClicked.index == index ? (
                    !showAimation[index] && jobCardDetailsList?.[index] ? (
                      <CreateNewSheetSolution
                        key={`${jobCardDetailsList[index].id}-${solId}`}
                        onClickCreateSolution={(e) =>
                          onClickCreateSolution(
                            e,
                            jobCardDetailsList[index].id,
                            jobCardDetailsList[index].uuid,
                            index
                          )
                        }
                        formValuesForStock={formValuesForStock?.[index]}
                        // job.jobcard.group.grouping_params.core_id
                        jobCardDetails={jobCardDetailsList[index].jobcard}
                        backButtonClicked={() =>
                          setCreateNewSolutionClicked({
                            isClicked: false,
                            index: -1,
                          })
                        }
                        stockSizesArray={
                          stockSizesByJobCard[jobCardDetailsList[index].id] || []
                        }
                        setStockSizesArray={(updatedStockSizes) => {
                          const selectedJobCardId = jobCardDetailsList[index]?.id;
                          if (!selectedJobCardId) return;
                          const nextStockSizes =
                            typeof updatedStockSizes === "function"
                              ? updatedStockSizes(
                                stockSizesByJobCard[selectedJobCardId] || []
                              )
                              : updatedStockSizes;
                          setStockSizes(nextStockSizes);
                          setStockSizesByJobCard((prev) => ({
                            ...prev,
                            [selectedJobCardId]: nextStockSizes,
                          }));
                        }}
                        createNewSolutionFormValuesForSizes={
                          createNewSolutionFormValuesByJobCard[
                          jobCardDetailsList[index].id
                          ]
                        }
                        type={"sheet"}
                        cutterType={cutter.type}
                        solutionId={solId}
                        completeJCDetails={jobCardDetailsList[index]}
                        unselectedOrders={
                          jobCardDetailsList[index]?.newlyCreatedJobCardsDetails
                            ? jobCardDetailsList[index]
                              ?.newlyCreatedJobCardsDetails[0]?.jobcard?.group
                              ?.unselected_orders
                            : jobCardDetailsList[index]?.jobcard?.group
                              ?.unselected_orders
                        }
                        machineData={location.state.body}
                        jobId={jobCardDetailsList[index].id}
                        dummy_orders={location.state.isDummyJC}
                        so_number={location.state.so}
                        ordersIdList={
                          ordersIdListByJobCard[jobCardDetailsList[index].id] ??
                          jobCardDetailsList[index]?.jobcard?.group?.orders?.map(
                            (order) => order.order_id
                          ) ??
                          []
                        }
                        updateOrdersIdList={(updatedOrdersIdList) => {
                          const selectedJobCardId = jobCardDetailsList[index]?.id;
                          if (!selectedJobCardId) return;
                          const nextOrdersIdList =
                            typeof updatedOrdersIdList === "function"
                              ? updatedOrdersIdList(
                                ordersIdListByJobCard[selectedJobCardId] || []
                              )
                              : updatedOrdersIdList;
                          setOrderIdList(nextOrdersIdList);
                          setOrdersIdListByJobCard((prev) => ({
                            ...prev,
                            [selectedJobCardId]: nextOrdersIdList,
                          }));
                        }}
                      ></CreateNewSheetSolution>
                    ) : (
                      <RightLayoutContainer>
                        <ContentMiddle>
                          <div className="imageAnimate">
                            <div className="imageCover">
                              <LottieAnimation lotti={JobcardPrepare} />
                              <p>
                                Our algorithms are cooking a job card for you{" "}
                                <br />
                                please wait, it will take less than a minute
                              </p>
                            </div>
                          </div>
                        </ContentMiddle>
                      </RightLayoutContainer>
                    )
                  ) : (
                    showAimation[index] ? (
                      <RightLayoutContainer>
                        <ContentMiddle>
                          <div className="imageAnimate">
                            <div className="imageCover">
                              <LottieAnimation lotti={JobcardPrepare} />
                              <p>
                                Our algorithms are cooking a job card for you{" "}
                                <br />
                                please wait, it will take less than a minute
                              </p>
                            </div>
                          </div>
                        </ContentMiddle>
                      </RightLayoutContainer>
                    ) : (
                      <>
                        <Tabs
                          defaultActiveKey="1"
                          className="topPostTab"
                          onChange={(activeKey) => {
                            setActiveTab('1');
                            setSizeExpanded(false);
                            setSizeExpanded(false);
                            setSizeExpanded(false);
                            setSizeExpanded(false);
                            setActiveKey(activeKey);
                          }}
                          activeKey={solId}
                          tabBarExtraContent={
                            !(
                              jobCardDetailsList[jobIndex]?.jobcard.solution_1
                                .data.status == "accept" ||
                              jobCardDetailsList[jobIndex]?.jobcard.solution_2
                                .data.status == "accept" ||
                              (jobCardDetailsList[jobIndex]
                                ?.newlyCreatedJobCardsDetails &&
                                jobCardDetailsList[jobIndex]
                                  ?.newlyCreatedJobCardsDetails[0].jobcard
                                  ?.solution_1?.data.status == "accept") ||
                              (jobCardDetailsList[jobIndex]
                                ?.newlyCreatedJobCardsDetails &&
                                jobCardDetailsList[jobIndex]
                                  ?.newlyCreatedJobCardsDetails[0].jobcard
                                  ?.solution_2.data.status == "accept")
                            ) && ordersIdList.length > 0 && (
                              <Button
                                key="5"
                                className="textTypeBtn"
                                onClick={() => onClickCreateNewSolution(index)}
                                disabled={
                                  !userDetails.roles.job_cards.edit ||
                                  !!showAimation?.[index] ||
                                  pendingJobCardsForNewSol?.some(
                                    (pendingJobCard) =>
                                      pendingJobCard?.uuid === job?.uuid ||
                                      pendingJobCard?.jobCardId === job?.id
                                  )
                                }
                                style={{ marginBottom: "3px" }}
                              >
                                <Iconmoon
                                  icon="addcircle"
                                  size={14}
                                  color="#ea655b"
                                  style={{
                                    paddingTop: "2px",
                                    marginRight: "3px",
                                  }}
                                />
                                Create New Solution
                              </Button>
                            )
                          }
                        >
                          <Panes tab="Solution 1" key="1">
                            <PageTitleComp style={{ borderBottom: "0" }}>
                              <PageHeader
                                ghost={false}
                                title={
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "50px",
                                    }}
                                  >
                                    <span>{job.state == "pending" ? (activeJC && activeJC != undefined ? activeJC : "") : ("Job Card " + (activeJC && activeJC != undefined ? activeJC : ""))}</span>
                                    {/* {job.state == "pending" ? (
                                  (activeJC?.length > 20 ? (
                                    <Tooltip placement="bottomLeft" title={activeJC}>
                                      {activeJC?.slice(0,21)+"..."}
                                    </Tooltip>
                                    ) : (
                                      activeJC
                                  ))
                                  ) : (
                                  ("Job Card " + activeJC)
                                  )
                                } */}
                                  </div>
                                }
                                extra={
                                  !job.jobcard.solution_1.data.exception && [
                                    job.jobcard.solution_1.data.status ==
                                      "accept" ? (
                                      <AlertContainer
                                        color="green"
                                        icon={alertGreen}
                                        msg="The solution is sent for approval"
                                      />
                                    ) : job.jobcard.solution_1.data.status ==
                                      "reject" ? (
                                      job.jobcard.solution_2.data.status ==
                                        "accept" ? (
                                        <AlertContainer
                                          color="green"
                                          icon={alertGreen}
                                          msg="The solution 2 is already accepted"
                                        />
                                      ) : job.newlyCreatedJobCardsDetails &&
                                        job.newlyCreatedJobCardsDetails[0].jobcard
                                          .solution_1?.data.status == "accept" ? (
                                        <AlertContainer
                                          color="green"
                                          icon={alertGreen}
                                          msg="The new solution 1 is already accepted"
                                        />
                                      ) : job.newlyCreatedJobCardsDetails &&
                                        job.newlyCreatedJobCardsDetails[0].jobcard
                                          .solution_2.data.status == "accept" ? (
                                        <AlertContainer
                                          color="green"
                                          icon={alertGreen}
                                          msg="The new solution 2 is already accepted"
                                        />
                                      ) : (
                                        <AlertContainer
                                          color="red"
                                          icon={alertRed}
                                          msg="The solution is discarded by the user"
                                        />
                                      )
                                    ) : (
                                      <RightSideSolution>
                                        <div className="rightSideSolutionButtons">
                                          <Button
                                            key="1"
                                            className="themeBtn noBg"
                                            onClick={() =>
                                              discardModalShow("solution1")
                                            }
                                            disabled={
                                              !userDetails.roles.job_cards.edit
                                            }
                                          >
                                            <Iconmoon
                                              icon="wrong"
                                              size={14}
                                              color="#EA4E2C"
                                            />
                                            Discard Solution
                                          </Button>
                                          <Button
                                            key="2"
                                            className="themeBtn"
                                            onClick={() =>
                                              acceptModalShow("solution1")
                                            }
                                            disabled={
                                              !userDetails.roles.job_cards.edit
                                            }
                                          >
                                            <Iconmoon
                                              icon="correct"
                                              size={14}
                                              color="#ffffff"
                                            />
                                            Accept Solution
                                          </Button>
                                        </div>
                                      </RightSideSolution>
                                    ),
                                  ]
                                }
                              ></PageHeader>
                            </PageTitleComp>
                            <div className="MatchResult">
                              <Row span={24} className="pipeBlockCylinder">
                                {(
                                  ((!sizeExpanded && activeTab == '2') ||
                                    (!sizeExpanded && activeTab == '3') ||
                                    (!sizeExpanded && activeTab == '4') ||
                                    (!sizeExpanded && activeTab == '5')) || activeTab == '1') && (<Col
                                      span={14}
                                      className="pipeBlock"
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <RightSideSolution>
                                        {!job.jobcard.solution_1.data.exception &&
                                          job.jobcard.solution_1.data.partitions &&
                                          job.jobcard.solution_1.data.partitions
                                            .length && solutionId == '1' ? (
                                          // jobCardDetailsList &&
                                          cutter.type == 'simplex' ? <SheetJobCardCylinderContainer
                                            jobId={job.id}
                                            solution={1}
                                            multiView={true}
                                            deckle_match_page={true}
                                            acceptedSolution={
                                              job.jobcard.solution_1.data
                                            }
                                            jobCard={job.jobcard}
                                            unitData={unitData}
                                          />
                                            : <DuplexJobCardCylinderContainer
                                              jobId={job.id}
                                              solution={1}
                                              multiView={true}
                                              deckle_match_page={true}
                                              acceptedSolution={
                                                job.jobcard.solution_1.data
                                              }
                                              jobCard={job.jobcard}
                                              unitData={unitData}
                                            />) : (
                                          <>
                                            <div className="deckleCoverImage">
                                              <img
                                                src={deckleCover}
                                                alt="deckle match result"
                                              />
                                            </div>
                                            {/* Exception message */}
                                            <div className="colLayoutBlock deckleErrorLayout">
                                              <p style={{ color: "#EA655B" }}>
                                                {
                                                  job.jobcard.solution_1.data
                                                    .exception
                                                }
                                              </p>
                                            </div>
                                          </>
                                        )}
                                      </RightSideSolution>
                                    </Col>
                                  )}
                                <Col span={
                                  ((sizeExpanded && activeTab == '2') ||
                                    (sizeExpanded && activeTab == '3') ||
                                    (sizeExpanded && activeTab == '4') ||
                                    (sizeExpanded && activeTab == '5')) && activeTab != '1'
                                    ? 24
                                    : 9
                                } className="colLayoutBlock">
                                  <Tabs
                                    className="topPostTab innerPostTab"
                                    defaultActiveKey={activeTab}
                                    activeKey={activeTab}
                                    onChange={tabChange}
                                  >
                                    <Panes
                                      tab="Solution 1 summary"
                                      key="1"
                                    // disabled={solutionSummary?.solution1.exception}
                                    >
                                      <div className="lossValue">
                                        {!job.jobcard.solution_1.data
                                          .exception && (
                                            <>
                                              <Row span={24}>
                                                <Col span={12}>
                                                  <div className="summaryValue">
                                                    <h5>
                                                      <span className="trimCut"></span>{" "}
                                                      Trim Loss
                                                    </h5>
                                                    <span>
                                                      {`${job.jobcard.solution_1.data.summary.match_trimloss_percent_area?.toFixed(
                                                        3
                                                      )} %`}
                                                    </span>

                                                    {
                                                      // job.jobcard.solution_1.data.summary
                                                      //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                      job.jobcard.comparison['match_area_trim_loss_(a-b)'] >
                                                        0 ? (
                                                        <span className="lesserSolution">
                                                          <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                          {job.jobcard.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                            job.jobcard.comparison['match_area_trim_loss_(a-b)']
                                                          ).toFixed(2) : 0}
                                                          % pts greater than sol 2
                                                        </span>
                                                      ) : (
                                                        <span className="lesserSolution">
                                                          <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                          {job.jobcard.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                            job.jobcard.comparison['match_area_trim_loss_(a-b)']
                                                          ).toFixed(2) : 0}
                                                          % pts lesser than sol 2
                                                        </span>
                                                      )
                                                      // ) : (
                                                      //   <></>
                                                      // )
                                                    }
                                                  </div>
                                                </Col>

                                                <Col span={12}>
                                                  <div className="summaryValue">
                                                    <h5>
                                                      <span className="trimBox"></span>{" "}
                                                      Fulfillment
                                                    </h5>
                                                    <span>
                                                      {`${job.jobcard.solution_1.data.summary.total_fulfillment_percent?.toFixed(
                                                        3
                                                      )} %`}
                                                    </span>
                                                    {
                                                      // job.jobcard.solution_1.data.summary
                                                      //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                      job.jobcard.comparison
                                                      ['total_fulfillment_weight%_(a-b)'] >
                                                        0 ? (
                                                        <span className="lesserSolution">
                                                          <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                          {job.jobcard.comparison
                                                          ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                            job.jobcard.comparison
                                                            ['total_fulfillment_weight%_(a-b)']
                                                          ).toFixed(2) : 0}
                                                          % pts greater than sol 2
                                                        </span>
                                                      ) : (
                                                        <span className="lesserSolution">
                                                          <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                          {job.jobcard.comparison
                                                          ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                            job.jobcard.comparison
                                                            ['total_fulfillment_weight%_(a-b)']
                                                          ).toFixed(2) : 0}
                                                          % pts lesser than sol 2
                                                        </span>
                                                      )
                                                      // ) : (
                                                      //   <></>
                                                      // )
                                                    }
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row span={24}>
                                                <Col span={12}>
                                                  <div className="summaryValue">
                                                    <h5>
                                                      <span className="trimCut"></span>{" "}
                                                      Net Trim Loss:{" "}
                                                      {`${job.jobcard.solution_1.data.summary.net_trimloss_percent_area?.toFixed(
                                                        3
                                                      )} `}
                                                      %
                                                      <p>
                                                        Loss including edge trim
                                                      </p>
                                                    </h5>
                                                  </div>
                                                </Col>
                                                <Col span={12}>
                                                  <div className="summaryValue">
                                                    <h5>
                                                      <span className="trimBox"></span>{" "}
                                                      Weight:{" "}
                                                      {`${job.jobcard.solution_1.data.summary.job_card_weight?.toFixed(
                                                        3
                                                      )} ${capitalize(weightUnit[job.jobcard.solution_1.data.summary.units?.job_card_weight].displayName)}`}

                                                      <p className="lesserSolution">
                                                        Total weight of Job Card
                                                      </p>
                                                    </h5>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </>
                                          )}
                                        <Row span={24}>
                                          <Col span={12}>
                                            <ul>
                                              <li>
                                                <span>Paper Machine</span>
                                                <p>
                                                  {
                                                    job.jobcard.group.machines[0]
                                                      .name
                                                  }
                                                </p>
                                              </li>
                                              <li>
                                                <span>Deckle Width</span>
                                                <p>{`${job.jobcard.group.machines[0].deckle_length_ub?.toFixed(
                                                  3
                                                )} - ${job.jobcard.group.machines[0].deckle_length_lb?.toFixed(
                                                  3
                                                )} ${(lengthUnit[job.jobcard.group.machines[0].units?.deckle_length_ub]?.displayName).toUpperCase()}`}</p>
                                              </li>

                                              <li>
                                                <span>
                                                  Product Specifications
                                                </span>
                                                <p style={{ wordWrap: "break-word" }}>
                                                  {
                                                    job.jobcard.group.product
                                                      .product_spec
                                                  }
                                                </p>
                                              </li>
                                              <li>
                                                <span>
                                                  Weight of Fulfilled Sheets
                                                </span>
                                                <p>
                                                  {job.jobcard.solution_1.data
                                                    .summary
                                                    .total_fulfillment_weight
                                                    ? `${job.jobcard.solution_1.data.summary.total_fulfillment_weight?.toFixed(
                                                      3
                                                    )} ${capitalize(weightUnit[job.jobcard.solution_1.data.summary.units?.total_fulfillment_weight]?.displayName)} `
                                                    : 0}
                                                </p>
                                              </li>
                                            </ul>
                                          </Col>
                                          <Col span={12}>
                                            <ul>
                                              <li>
                                                <span>Cutter</span>
                                                <p>
                                                  {
                                                    job.jobcard.group.machines[0]
                                                      .cutter_name
                                                  }
                                                </p>
                                              </li>
                                              <li>
                                                <span>
                                                  Edge Trim ( Left / Right)
                                                </span>
                                                <p>{`${job.jobcard.group.machines[0].left_edge_trim} ${(lengthUnit[job.jobcard.group.machines[0].units?.left_edge_trim]?.displayName).toUpperCase()} / ${job.jobcard.group.machines[0].right_edge_trim} ${(lengthUnit[job.jobcard.group.machines[0].units?.right_edge_trim]?.displayName).toUpperCase()}`}</p>
                                              </li>
                                              <li>
                                                <span>Number Unique of Sets</span>
                                                <p>
                                                  {job.jobcard.solution_1.data
                                                    .summary.total_unique_patterns
                                                    ? job.jobcard.solution_1.data
                                                      .summary
                                                      .total_unique_patterns
                                                    : 0}
                                                </p>
                                              </li>
                                              <li>
                                                <span>
                                                  Weight of Priority Sheets
                                                </span>
                                                <p>
                                                  {job.jobcard.solution_1.data
                                                    .summary.fulfillment_priority_fulfillment_weight
                                                    ? job.jobcard.solution_1.data
                                                      .summary
                                                      .fulfillment_priority_fulfillment_weight.toFixed(3) + ' ' + capitalize(weightUnit[job.jobcard.solution_1.data
                                                        .summary.units
                                                        ?.fulfillment_priority_fulfillment_weight]?.displayName)
                                                    : 0}
                                                </p>
                                              </li>
                                            </ul>
                                          </Col>
                                        </Row>
                                        {/* Removed Approved Remarks */}
                                      </div>
                                    </Panes>
                                    <Panes
                                      tab={
                                        <span>
                                          Size Fulfilment
                                          {activeTab == "2" && (
                                            <Button
                                              key="1"
                                              style={{ border: "none" }}
                                              onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                            >
                                              <Iconmoon
                                                icon={
                                                  sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                }
                                                size={14}
                                                color="#EA4E2C"
                                              />
                                            </Button>
                                          )}
                                        </span>
                                      }
                                      key="2">
                                      <TableLayoutData>
                                        <div
                                          className="tableDataFormat  "
                                          style={{ marginTop: "25px" }}
                                        >
                                          <Table
                                            columns={sizeFulfillmentColumnsHead}
                                            dataSource={sizeFulfillmentSolution1}
                                            onChange={onChange}
                                            scroll={{ x: 1200 }}
                                            rowClassName={(record) =>
                                              record.priority && "true"
                                            }
                                          />
                                        </div>
                                      </TableLayoutData>
                                    </Panes>
                                    {!job.jobcard.solution_1.data.exception && (
                                      <Panes
                                        tab={
                                          <span>
                                            Order Fulfillment
                                            {activeTab == "3" && (
                                              <Button
                                                key="1"
                                                style={{ border: "none" }}
                                                onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                              >
                                                <Iconmoon
                                                  icon={
                                                    sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                  }
                                                  size={14}
                                                  color="#EA4E2C"
                                                />
                                              </Button>
                                            )}
                                          </span>
                                        }
                                        key="3"
                                      // disabled={solutionSummary?.solution1.exception}
                                      >
                                        <TableLayoutData>
                                          <div
                                            className="tableDataFormat"
                                            style={{ marginTop: "25px" }}
                                          >
                                            <Table
                                              columns={orderFulfillmentColumnsHead}
                                              dataSource={orderDetailsList1}
                                              onChange={onChange}
                                              scroll={{ x: 1800 }}
                                              rowClassName={(record) =>
                                                record.priority && "true"
                                              }
                                            />
                                          </div>
                                        </TableLayoutData>
                                      </Panes>
                                    )}
                                    {/* <Panes
                                           tab={
                                    <span>
                                        Unfulfilled Orders
                                        {activeTab == "4" && (
                                          <Button
                                            key="1"
                                            style={{ border: "none" }}
                                            onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                          >
                                            <Iconmoon
                                              icon={
                                                sizeExpanded ? "contract_arrow" : "expand_arrow"
                                              }
                                              size={14}
                                              color="#EA4E2C"
                                            />
                                          </Button>
                                        )}
                                      </span>
                                    }                                      
                                    key="4"
                                    // disabled={solutionSummary?.solution1.exception}
                                  >
                                    <TableLayoutData>
                                      <div
                                        className="tableDataFormat"
                                        style={{ marginTop: "25px" }}
                                      >
                                        <Table
                                          columns={unfulfilledColumnsHead}
                                          dataSource={
                                            job.jobcard.solution_1.data
                                              .exception
                                              ? failedJobOrders
                                              : orderDetailsList1?.filter(
                                                  (order) =>
                                                    order.unFulflilledReels > 0
                                                )
                                          }
                                          onChange={onChange}
                                          scroll={{ x: 1800 }}
                                          rowClassName={(record) =>
                                            record.priority && "true"
                                          }
                                        />
                                      </div>
                                    </TableLayoutData>
                                  </Panes> */}
                                  </Tabs>
                                </Col>
                              </Row>
                            </div>
                          </Panes>

                          {job.jobcard.solution_2.data.summary && (
                            <Panes tab="Solution 2" key="2">
                              <PageTitleComp style={{ borderBottom: "0" }}>
                                <PageHeader
                                  ghost={false}
                                  title={
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "50px",
                                      }}
                                    >
                                      <span>{job.state == "pending" ? (activeJC && activeJC != undefined ? activeJC : "") : ("Job Card " + (activeJC && activeJC != undefined ? activeJC : ""))}</span>
                                      {/* {job.state == "pending" ? (
                                      (activeJC?.length > 20 ? (
                                        <Tooltip placement="bottomLeft" title={activeJC}>
                                          {activeJC?.slice(0,21)+"..."}
                                        </Tooltip>
                                        ) : (
                                          activeJC
                                      ))
                                      ) : (
                                      ("Job Card " + activeJC)
                                      )
                                    } */}
                                    </div>
                                  }
                                  extra={
                                    !job.jobcard.solution_2.data.exception && [
                                      job.jobcard.solution_2.data.status ==
                                        "accept" ? (
                                        <AlertContainer
                                          color="green"
                                          icon={alertGreen}
                                          msg="The solution is sent for approval"
                                        />
                                      ) : job.jobcard.solution_2.data.status ==
                                        "reject" ? (
                                        job.jobcard.solution_1.data.status ==
                                          "accept" ? (
                                          <AlertContainer
                                            color="green"
                                            icon={alertGreen}
                                            msg="The solution 1 is already accepted"
                                          />
                                        ) : job.newlyCreatedJobCardsDetails &&
                                          job.newlyCreatedJobCardsDetails[0]
                                            .jobcard.solution_1.data.status ==
                                          "accept" ? (
                                          <AlertContainer
                                            color="green"
                                            icon={alertGreen}
                                            msg="The new solution 1 is already accepted"
                                          />
                                        ) : job.newlyCreatedJobCardsDetails &&
                                          job.newlyCreatedJobCardsDetails[0]
                                            .jobcard.solution_2.data.status ==
                                          "accept" ? (
                                          <AlertContainer
                                            color="green"
                                            icon={alertGreen}
                                            msg="The new solution 2 is already accepted"
                                          />
                                        ) : (
                                          <AlertContainer
                                            color="red"
                                            icon={alertRed}
                                            msg="The solution is discarded by the user"
                                          />
                                        )
                                      ) : (
                                        <RightSideSolution>
                                          <div className="rightSideSolutionButtons">
                                            <Button
                                              key="1"
                                              className="themeBtn noBg"
                                              onClick={() =>
                                                discardModalShow("solution2")
                                              }
                                            // disabled={
                                            //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.data.exception
                                            // }
                                            >
                                              <Iconmoon
                                                icon="wrong"
                                                size={14}
                                                color="#EA4E2C"
                                              />
                                              Discard Solution
                                            </Button>

                                            <Button
                                              key="2"
                                              className="themeBtn"
                                              onClick={() =>
                                                acceptModalShow("solution2")
                                              }
                                            // disabled={
                                            //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.data.exception
                                            // }
                                            >
                                              <Iconmoon
                                                icon="correct"
                                                size={14}
                                                color="#ffffff"
                                              />
                                              Accept Solution
                                            </Button>
                                          </div>
                                        </RightSideSolution>
                                      ),
                                    ]
                                  }
                                ></PageHeader>
                              </PageTitleComp>
                              <div className="MatchResult">
                                <Row span={24} className="pipeBlockCylinder">
                                  {(
                                    ((!sizeExpanded && activeTab == '2') ||
                                      (!sizeExpanded && activeTab == '3') ||
                                      (!sizeExpanded && activeTab == '4') ||
                                      (!sizeExpanded && activeTab == '5')) || activeTab == '1') && (<Col
                                        span={14}
                                        className="pipeBlock"
                                        style={{ paddingRight: "20px" }}
                                      >
                                        <RightSideSolution>
                                          {!job.jobcard.solution_2.data.exception &&
                                            job.jobcard.solution_2.data.partitions &&
                                            job.jobcard.solution_2.data.partitions
                                              .length && solutionId == '2' ? (
                                            // jobCardDetailsList && (
                                            cutter.type == 'simplex' ? <SheetJobCardCylinderContainer
                                              jobId={job.id}
                                              solution={2}
                                              multiView={true}
                                              deckle_match_page={true}
                                              acceptedSolution={
                                                job.jobcard.solution_2.data
                                              }
                                              jobCard={job.jobcard}
                                              unitData={unitData}
                                            /> :
                                              <DuplexJobCardCylinderContainer
                                                jobId={job.id}
                                                solution={2}
                                                multiView={true}
                                                deckle_match_page={true}
                                                acceptedSolution={
                                                  job.jobcard.solution_2.data
                                                }
                                                jobCard={job.jobcard}
                                                unitData={unitData}
                                              />
                                          ) : (
                                            // )
                                            <>
                                              <div className="deckleCoverImage">
                                                <img
                                                  src={deckleCover}
                                                  alt="deckle match result"
                                                />
                                              </div>
                                              {/* Exception message */}
                                              <div className="colLayoutBlock deckleErrorLayout">
                                                <p style={{ color: "#EA655B" }}>
                                                  {
                                                    job.jobcard.solution_2.data
                                                      .exception
                                                  }
                                                </p>
                                              </div>
                                            </>
                                          )}
                                        </RightSideSolution>
                                      </Col>
                                    )}
                                  <Col span={
                                    ((sizeExpanded && activeTab == '2') ||
                                      (sizeExpanded && activeTab == '3') ||
                                      (sizeExpanded && activeTab == '4') ||
                                      (sizeExpanded && activeTab == '5')) && activeTab != '1'
                                      ? 24
                                      : 9
                                  } className="colLayoutBlock">
                                    {/* Exception message */}
                                    {/* {!jobCardDetailsList[jobIndex]?.solution2.summary ? (
                            <></>
                          ) : (
                            <p style={{ color: "#EA655B" }}>
                              {job.solution2.exception}
                            </p>
                          )} */}
                                    <Tabs
                                      defaultActiveKey={activeTab}
                                      activeKey={activeTab}
                                      onChange={tabChange}
                                      className="topPostTab innerPostTab"
                                    >
                                      <Panes
                                        tab="Solution 2 summary"
                                        key="1"
                                      // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                      >
                                        <div className="lossValue">
                                          {!job.jobcard.solution_2.data
                                            .exception && (
                                              <>
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimCut"></span>{" "}
                                                        Trim Loss
                                                      </h5>
                                                      <span>
                                                        {`${job.jobcard.solution_2.data.summary.match_trimloss_percent_area.toFixed(3)} %`}
                                                      </span>
                                                      {
                                                        // job.jobcard.solution_1.data.summary
                                                        //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                        job.jobcard.comparison['match_area_trim_loss_(a-b)'] <
                                                          0 ? (
                                                          <span className="lesserSolution">
                                                            <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                            {job.jobcard.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                              job.jobcard.comparison['match_area_trim_loss_(a-b)']
                                                            ).toFixed(2) : 0}
                                                            % pts greater than sol 1
                                                          </span>
                                                        ) : (
                                                          <span className="lesserSolution">
                                                            <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                            {job.jobcard.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                              job.jobcard.comparison['match_area_trim_loss_(a-b)']
                                                            ).toFixed(2) : 0}
                                                            % pts lesser than sol 1
                                                          </span>
                                                        )
                                                        // ) : (
                                                        //   <></>
                                                        // )
                                                      }
                                                    </div>
                                                  </Col>
                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimBox"></span>{" "}
                                                        Fulfillment
                                                      </h5>
                                                      <span>
                                                        {`${job.jobcard.solution_2.data.summary.total_fulfillment_percent?.toFixed(
                                                          3
                                                        )} %`}
                                                      </span>

                                                      {
                                                        // job.jobcard.solution_1.data.summary
                                                        //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                        job.jobcard.comparison
                                                        ['total_fulfillment_weight%_(a-b)'] <
                                                          0 ? (
                                                          <span className="lesserSolution">
                                                            <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                            {job.jobcard.comparison
                                                            ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                              job.jobcard.comparison
                                                              ['total_fulfillment_weight%_(a-b)']
                                                            ).toFixed(2) : 0}
                                                            % pts greater than sol 1
                                                          </span>
                                                        ) : (
                                                          <span className="lesserSolution">
                                                            <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                            {job.jobcard.comparison
                                                            ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                              job.jobcard.comparison
                                                              ['total_fulfillment_weight%_(a-b)']
                                                            ).toFixed(2) : 0}
                                                            % pts lesser than sol 1
                                                          </span>
                                                        )
                                                        // ) : (
                                                        //   <></>
                                                        // )
                                                      }
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimCut"></span>{" "}
                                                        Net Trim Loss:{" "}
                                                        {`${job.jobcard.solution_2.data.summary.net_trimloss_percent_area?.toFixed(
                                                          3
                                                        )} `}
                                                        %
                                                        <p>
                                                          Loss including edge trim
                                                        </p>
                                                      </h5>
                                                    </div>
                                                  </Col>
                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimBox"></span>{" "}
                                                        Weight:{" "}
                                                        {`${job.jobcard.solution_2.data.summary.job_card_weight?.toFixed(
                                                          3
                                                        )} ${capitalize(weightUnit[job.jobcard.solution_2.data.summary.units?.job_card_weight]?.displayName)}`}
                                                        <p className="lesserSolution">
                                                          Total weight of Job Card
                                                        </p>
                                                      </h5>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </>
                                            )}
                                          <Row span={24}>
                                            <Col span={12}>
                                              <ul>
                                                <li>
                                                  <span>Paper Machine</span>
                                                  <p>
                                                    {
                                                      job.jobcard.group
                                                        .machines[0].name
                                                    }
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>Deckle Width</span>
                                                  <p>{`${job.jobcard.group.machines[0].deckle_length_ub?.toFixed(
                                                    3
                                                  )} - ${job.jobcard.group.machines[0].deckle_length_lb?.toFixed(
                                                    3
                                                  )} ${(lengthUnit[job.jobcard.group.machines[0].units?.deckle_length_ub]?.displayName).toUpperCase()}`}</p>
                                                </li>

                                                <li>
                                                  <span>
                                                    Product Specifications
                                                  </span>
                                                  <p style={{ wordWrap: "break-word" }}>
                                                    {
                                                      job.jobcard.group.product
                                                        .product_spec
                                                    }
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Weight of Fulfilled Sheets
                                                  </span>
                                                  <p>
                                                    {/* {console.log(
                                                "i",
                                                job.jobcard.solution_2.data.data
                                                  .summary.requirement_fulfilled
                                              )} */}
                                                    {job.jobcard.solution_2.data
                                                      .summary
                                                      .total_fulfillment_weight
                                                      ? `${job.jobcard.solution_2.data.summary.total_fulfillment_weight?.toFixed(
                                                        3
                                                      )} ${capitalize(weightUnit[job.jobcard.solution_2.data.summary.units?.total_fulfillment_weight]?.displayName)}`
                                                      : 0}
                                                  </p>
                                                </li>
                                              </ul>
                                            </Col>
                                            <Col span={12}>
                                              <ul>
                                                <li>
                                                  <span>Cutter</span>
                                                  <p>
                                                    {
                                                      job.jobcard.group
                                                        .machines[0].cutter_name
                                                    }
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Edge Trim ( Left / Right)
                                                  </span>
                                                  <p>{`${job.jobcard.group.machines[0].left_edge_trim} ${(lengthUnit[job.jobcard.group.machines[0].units?.left_edge_trim]?.displayName).toUpperCase()} / ${job.jobcard.group.machines[0].right_edge_trim} ${(lengthUnit[job.jobcard.group.machines[0].units?.right_edge_trim]?.displayName).toUpperCase()}`}</p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Number Unique of Sets
                                                  </span>
                                                  <p>
                                                    {job.jobcard.solution_2.data
                                                      .summary
                                                      .total_unique_patterns
                                                      ? job.jobcard.solution_2
                                                        .data.summary
                                                        .total_unique_patterns
                                                      : 0}
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Weight of Priority Sheets
                                                  </span>
                                                  <p>
                                                    {job.jobcard.solution_2.data
                                                      .summary.fulfillment_priority_fulfillment_weight
                                                      ? job.jobcard.solution_2
                                                        .data.summary
                                                        .fulfillment_priority_fulfillment_weight.toFixed(3) + ' ' + capitalize(weightUnit[job.jobcard.solution_2
                                                          .data.summary.units
                                                          ?.fulfillment_priority_fulfillment_weight]?.displayName)
                                                      : 0}
                                                  </p>
                                                </li>
                                              </ul>
                                            </Col>
                                          </Row>
                                          {/* Removed Approved Remarks     */}
                                        </div>
                                      </Panes>
                                      <Panes
                                        tab={
                                          <span>
                                            Size Fulfilment
                                            {activeTab == "2" && (
                                              <Button
                                                key="1"
                                                style={{ border: "none" }}
                                                onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                              >
                                                <Iconmoon
                                                  icon={
                                                    sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                  }
                                                  size={14}
                                                  color="#EA4E2C"
                                                />
                                              </Button>
                                            )}
                                          </span>
                                        }
                                        key="2">
                                        <TableLayoutData>
                                          <div
                                            className="tableDataFormat  "
                                            style={{ marginTop: "25px" }}
                                          >
                                            <Table
                                              columns={sizeFulfillmentColumnsHead}
                                              dataSource={
                                                sizeFulfillmentSolution2
                                              }
                                              onChange={onChange}
                                              scroll={{ x: 1200 }}
                                              rowClassName={(record) =>
                                                record.priority && "true"
                                              }
                                            />
                                          </div>
                                        </TableLayoutData>
                                      </Panes>
                                      {!job.jobcard.solution_2.data.exception && (
                                        <Panes
                                          tab={
                                            <span>
                                              Order Fulfillment
                                              {activeTab == "3" && (
                                                <Button
                                                  key="1"
                                                  style={{ border: "none" }}
                                                  onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                                >
                                                  <Iconmoon
                                                    icon={
                                                      sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                    }
                                                    size={14}
                                                    color="#EA4E2C"
                                                  />
                                                </Button>
                                              )}
                                            </span>
                                          }
                                          key="3"
                                        // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                        >
                                          <TableLayoutData>
                                            <div
                                              className="tableDataFormat"
                                              style={{ marginTop: "25px" }}
                                            >
                                              <Table
                                                columns={orderFulfillmentColumnsHead}
                                                dataSource={orderDetailsList2}
                                                onChange={onChange}
                                                scroll={{ x: 1800 }}
                                                rowClassName={(record) =>
                                                  record.priority && "true"
                                                }
                                              />
                                            </div>
                                          </TableLayoutData>
                                        </Panes>
                                      )}
                                      {/* <Panes
                                          tab={
                                   <span>
                                       Unfulfilled Orders
                                       {activeTab == "4" && (
                                         <Button
                                           key="1"
                                           style={{ border: "none" }}
                                           onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                         >
                                           <Iconmoon
                                             icon={
                                               sizeExpanded ? "contract_arrow" : "expand_arrow"
                                             }
                                             size={14}
                                             color="#EA4E2C"
                                           />
                                         </Button>
                                       )}
                                     </span>
                                   }     
                                                                         key="4"
                                      // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                    >
                                      <TableLayoutData>
                                        <div
                                          className="tableDataFormat"
                                          style={{ marginTop: "25px" }}
                                        >
                                          <Table
                                            columns={unfulfilledColumnsHead}
                                            dataSource={
                                              job.jobcard.solution_1.data
                                                .exception
                                                ? failedJobOrders
                                                : orderDetailsList2?.filter(
                                                    (order) =>
                                                      (order.unFulflilledReels >
                                                      0)
                                                  )
                                            }
                                            onChange={onChange}
                                            scroll={{ x: 1800 }}
                                            rowClassName={(record) =>
                                              record.priority && "true"
                                            }
                                          />
                                        </div>
                                      </TableLayoutData>
                                    </Panes> */}
                                    </Tabs>
                                  </Col>
                                </Row>
                              </div>
                            </Panes>
                          )}

                          {job.newlyCreatedJobCardsDetails && (
                            <Panes tab="New Solution 1" key="3">
                              <PageTitleComp style={{ borderBottom: "0" }}>
                                <PageHeader
                                  ghost={false}
                                  title={
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "50px",
                                      }}
                                    >
                                      <span>{job.state == "pending" ? (activeJC && activeJC != undefined ? activeJC : "") : ("Job Card " + (activeJC && activeJC != undefined ? activeJC : ""))}</span>
                                      {/* {job.state == "pending" ? (
                                      (activeJC?.length > 20 ? (
                                        <Tooltip placement="bottomLeft" title={activeJC}>
                                          {activeJC?.slice(0,21)+"..."}
                                        </Tooltip>
                                        ) : (
                                          activeJC
                                      ))
                                      ) : (
                                      ("Job Card " + activeJC)
                                      )
                                    } */}
                                    </div>
                                  }
                                  extra={
                                    !job.newlyCreatedJobCardsDetails[0].jobcard
                                      ?.solution_1.data.exception && [
                                      job.newlyCreatedJobCardsDetails[0].jobcard
                                        ?.solution_1.data.status == "accept" ? (
                                        <AlertContainer
                                          color="green"
                                          icon={alertGreen}
                                          msg="The solution is sent for approval"
                                        />
                                      ) : job.newlyCreatedJobCardsDetails[0]
                                        .jobcard?.solution_1.data.status ==
                                        "reject" ? (
                                        job.newlyCreatedJobCardsDetails[0].jobcard
                                          ?.solution_2.data.status == "accept" ? (
                                          <AlertContainer
                                            color="green"
                                            icon={alertGreen}
                                            msg="The new solution 2 is already accepted"
                                          />
                                        ) : job.jobcard?.solution_1.data.status ==
                                          "accept" ? (
                                          <AlertContainer
                                            color="green"
                                            icon={alertGreen}
                                            msg="The solution 1 is already accepted"
                                          />
                                        ) : job.jobcard?.solution_2.data.status ==
                                          "accept" ? (
                                          <AlertContainer
                                            color="green"
                                            icon={alertGreen}
                                            msg="The solution 2 is already accepted"
                                          />
                                        ) : (
                                          <AlertContainer
                                            color="red"
                                            icon={alertRed}
                                            msg="The solution is discarded by the user"
                                          />
                                        )
                                      ) : job.newlyCreatedJobCardsDetails[0].jobcard
                                        ?.solution_1.data
                                        .summary ? (
                                        <RightSideSolution>
                                          <div className="rightSideSolutionButtons">
                                            <Button
                                              key="1"
                                              className="themeBtn noBg"
                                              onClick={() =>
                                                discardModalShow("solution1")
                                              }
                                              disabled={
                                                !userDetails.roles.job_cards.edit
                                              }
                                            >
                                              <Iconmoon
                                                icon="wrong"
                                                size={14}
                                                color="#EA4E2C"
                                              />
                                              Discard Solution
                                            </Button>
                                            <Button
                                              key="2"
                                              className="themeBtn"
                                              onClick={() =>
                                                acceptModalShow("solution1")
                                              }
                                              disabled={
                                                !userDetails.roles.job_cards.edit
                                              }
                                            >
                                              <Iconmoon
                                                icon="correct"
                                                size={14}
                                                color="#ffffff"
                                              />
                                              Accept Solution
                                            </Button>
                                          </div>
                                        </RightSideSolution>
                                      ) : '',
                                    ]
                                  }
                                ></PageHeader>
                              </PageTitleComp>
                              <div className="MatchResult">
                                <Row span={24} className="pipeBlockCylinder">
                                  {(
                                    ((!sizeExpanded && activeTab == '2') ||
                                      (!sizeExpanded && activeTab == '3') ||
                                      (!sizeExpanded && activeTab == '4') ||
                                      (!sizeExpanded && activeTab == '5')) || activeTab == '1') && (<Col
                                        span={14}
                                        className="pipeBlock"
                                        style={{ paddingRight: "20px" }}
                                      >
                                        <RightSideSolution>
                                          {!job.newlyCreatedJobCardsDetails[0].jobcard
                                            ?.solution_1.data.exception && solutionId == '3' && job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.partitions &&
                                            job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.partitions
                                              .length ? (
                                            // jobCardDetailsList &&
                                            cutter.type == 'simplex' ? <SheetJobCardCylinderContainer
                                              jobId={
                                                job.newlyCreatedJobCardsDetails[0].id
                                              }
                                              solution={1}
                                              multiView={true}
                                              deckle_match_page={true}
                                              acceptedSolution={
                                                job.newlyCreatedJobCardsDetails[0]
                                                  .jobcard?.solution_1.data
                                              }
                                              jobCard={job.newlyCreatedJobCardsDetails[0].jobcard}
                                              unitData={unitData}
                                            /> :
                                              <DuplexJobCardCylinderContainer
                                                jobId={
                                                  job.newlyCreatedJobCardsDetails[0].id
                                                }
                                                solution={1}
                                                multiView={true}
                                                deckle_match_page={true}
                                                acceptedSolution={
                                                  job.newlyCreatedJobCardsDetails[0]
                                                    .jobcard?.solution_1.data
                                                }
                                                jobCard={job.newlyCreatedJobCardsDetails[0].jobcard}
                                                unitData={unitData}
                                              />
                                          ) : (
                                            <>
                                              <div className="deckleCoverImage">
                                                <img
                                                  src={deckleCover}
                                                  alt="deckle match result"
                                                />
                                              </div>
                                              {/* Exception message */}
                                              <div className="colLayoutBlock deckleErrorLayout">
                                                <p style={{ color: "#EA655B" }}>
                                                  {
                                                    job.newlyCreatedJobCardsDetails[0]
                                                      .jobcard?.solution_1.data
                                                      .exception
                                                  }
                                                </p>
                                              </div>
                                            </>
                                          )}
                                        </RightSideSolution>
                                      </Col>
                                    )}
                                  <Col span={
                                    ((sizeExpanded && activeTab == '2') ||
                                      (sizeExpanded && activeTab == '3') ||
                                      (sizeExpanded && activeTab == '4') ||
                                      (sizeExpanded && activeTab == '5')) && activeTab != '1'
                                      ? 24
                                      : 9
                                  } className="colLayoutBlock">
                                    <Tabs
                                      defaultActiveKey={activeTab}
                                      activeKey={activeTab}
                                      onChange={tabChange}
                                      className="topPostTab innerPostTab"
                                    >
                                      <Panes
                                        tab="Solution 1 summary"
                                        key="1"
                                      // disabled={solutionSummary?.solution1.exception}
                                      >
                                        <div className="lossValue">
                                          {!job.newlyCreatedJobCardsDetails[0]
                                            .jobcard?.solution_1.data
                                            .exception && job.newlyCreatedJobCardsDetails[0]
                                              .jobcard?.solution_1.data.summary && (
                                              <>
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimCut"></span>{" "}
                                                        Trim Loss
                                                      </h5>
                                                      <span>
                                                        {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.summary.match_trimloss_percent_area.toFixed(
                                                          3
                                                        )} %`}
                                                      </span>
                                                      {
                                                        // job.jobcard.solution_1.data.summary
                                                        //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                        job.newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.comparison['match_area_trim_loss_(a-b)'] >
                                                          0 ? (
                                                          <span className="lesserSolution">
                                                            <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                            {job.newlyCreatedJobCardsDetails[0]
                                                              .jobcard?.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                                job.newlyCreatedJobCardsDetails[0]
                                                                  .jobcard?.comparison['match_area_trim_loss_(a-b)']
                                                              ).toFixed(2) : 0}
                                                            % pts greater than new sol 2
                                                          </span>
                                                        ) : (
                                                          <span className="lesserSolution">
                                                            <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                            {job.newlyCreatedJobCardsDetails[0]
                                                              .jobcard?.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                                job.newlyCreatedJobCardsDetails[0]
                                                                  .jobcard?.comparison['match_area_trim_loss_(a-b)']
                                                              ).toFixed(2) : 0}
                                                            % pts lesser than new sol 2
                                                          </span>
                                                        )
                                                        // ) : (
                                                        //   <></>
                                                        // )
                                                      }
                                                    </div>
                                                  </Col>

                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimBox"></span>{" "}
                                                        Fulfillment
                                                      </h5>
                                                      <span>
                                                        {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.summary.total_fulfillment_percent.toFixed(
                                                          3
                                                        )} %`}
                                                      </span>
                                                      {
                                                        // job.jobcard.solution_1.data.summary
                                                        //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.comparison
                                                        ['total_fulfillment_weight%_(a-b)'] >
                                                          0 ? (
                                                          <span className="lesserSolution">
                                                            <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                            {job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard?.comparison
                                                            ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                              job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                .jobcard?.comparison
                                                              ['total_fulfillment_weight%_(a-b)']
                                                            ).toFixed(2) : 0}
                                                            % pts greater than new sol 2
                                                          </span>
                                                        ) : (
                                                          <span className="lesserSolution">
                                                            <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                            {job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard?.comparison
                                                            ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                              job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                .jobcard?.comparison
                                                              ['total_fulfillment_weight%_(a-b)']
                                                            ).toFixed(2) : 0}
                                                            % pts lesser than new sol 2
                                                          </span>
                                                        )
                                                        // ) : (
                                                        //   <></>
                                                        // )
                                                      }
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimCut"></span>{" "}
                                                        Net Trim Loss:{" "}
                                                        {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.summary.net_trimloss_percent_area.toFixed(
                                                          3
                                                        )} `}
                                                        %
                                                        <p>
                                                          Loss including edge trim
                                                        </p>
                                                      </h5>
                                                    </div>
                                                  </Col>
                                                  <Col span={12}>
                                                    <div className="summaryValue">
                                                      <h5>
                                                        <span className="trimBox"></span>{" "}
                                                        Weight:{" "}
                                                        {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.summary.job_card_weight.toFixed(
                                                          3
                                                        )} ${capitalize(weightUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.summary.units?.job_card_weight]?.displayName)}`}

                                                        <p className="lesserSolution">
                                                          Total weight of Job Card
                                                        </p>
                                                      </h5>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </>
                                            )}
                                          <Row span={24}>
                                            <Col span={12}>
                                              <ul>
                                                <li>
                                                  <span>Paper Machine</span>
                                                  <p>
                                                    {
                                                      job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.group.machines[0]
                                                        .name
                                                    }
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>Deckle Width</span>
                                                  <p>{`${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].deckle_length_ub?.toFixed(
                                                    3
                                                  )} - ${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].deckle_length_lb?.toFixed(
                                                    3
                                                  )} ${(lengthUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].units?.deckle_length_ub]?.displayName).toUpperCase()}`}</p>
                                                </li>

                                                <li>
                                                  <span>
                                                    Product Specifications
                                                  </span>
                                                  <p style={{ wordWrap: "break-word" }}>
                                                    {
                                                      job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.group.product
                                                        .product_spec
                                                    }
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Weight of Fulfilled Sheets
                                                  </span>
                                                  <p>
                                                    {job
                                                      .newlyCreatedJobCardsDetails[0]
                                                      .jobcard?.solution_1.data
                                                      .summary
                                                      ?.total_fulfillment_weight
                                                      ? `${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.summary.total_fulfillment_weight.toFixed(
                                                        3
                                                      )} ${capitalize(weightUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.solution_1.data.summary.units?.total_fulfillment_weight]?.displayName)} `
                                                      : 0}
                                                  </p>
                                                </li>
                                              </ul>
                                            </Col>
                                            <Col span={12}>
                                              <ul>
                                                <li>
                                                  <span>Cutter</span>
                                                  <p>
                                                    {
                                                      job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.group.machines[0]
                                                        .cutter_name
                                                    }
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Edge Trim ( Left / Right)
                                                  </span>
                                                  <p>{`${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].left_edge_trim} ${(lengthUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].units?.left_edge_trim]?.displayName).toUpperCase()} / ${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].right_edge_trim} ${(lengthUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].units?.right_edge_trim].displayName).toUpperCase()}`}</p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Number of Unique Sets
                                                  </span>
                                                  <p>
                                                    {job
                                                      .newlyCreatedJobCardsDetails[0]
                                                      .jobcard?.solution_1.data
                                                      .summary
                                                      ?.total_unique_patterns
                                                      ? job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.solution_1.data
                                                        .summary
                                                        ?.total_unique_patterns
                                                      : 0}
                                                  </p>
                                                </li>
                                                <li>
                                                  <span>
                                                    Weight of Priority Sheets
                                                  </span>
                                                  <p>
                                                    {job
                                                      .newlyCreatedJobCardsDetails[0]
                                                      .jobcard?.solution_1.data
                                                      .summary?.fulfillment_priority_fulfillment_weight
                                                      ? job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.solution_1.data
                                                        ?.summary
                                                        .fulfillment_priority_fulfillment_weight.toFixed(3) + ' ' + capitalize(weightUnit[job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.solution_1.data
                                                          ?.summary.units
                                                          ?.fulfillment_priority_fulfillment_weight]?.displayName)
                                                      : 0}
                                                  </p>
                                                </li>
                                              </ul>
                                            </Col>
                                          </Row>
                                          {/* Removed Approved Remarks */}
                                        </div>
                                      </Panes>
                                      <Panes
                                        tab={
                                          <span>
                                            Size Fulfilment
                                            {activeTab == "2" && (
                                              <Button
                                                key="1"
                                                style={{ border: "none" }}
                                                onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                              >
                                                <Iconmoon
                                                  icon={
                                                    sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                  }
                                                  size={14}
                                                  color="#EA4E2C"
                                                />
                                              </Button>
                                            )}
                                          </span>
                                        }
                                        key="2">
                                        <TableLayoutData>
                                          <div
                                            className="tableDataFormat  "
                                            style={{ marginTop: "25px" }}
                                          >
                                            <Table
                                              columns={sizeFulfillmentColumnsHead}
                                              dataSource={
                                                sizeFulfillmentNewSolution1
                                              }
                                              onChange={onChange}
                                              scroll={{ x: 1200 }}
                                              rowClassName={(record) =>
                                                record.priority && "true"
                                              }
                                            />
                                          </div>
                                        </TableLayoutData>
                                      </Panes>
                                      {!job.newlyCreatedJobCardsDetails[0].jobcard
                                        ?.solution_1.data.exception && (
                                          <Panes
                                            tab={
                                              <span>
                                                Order Fulfillment
                                                {activeTab == "3" && (
                                                  <Button
                                                    key="1"
                                                    style={{ border: "none" }}
                                                    onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                                  >
                                                    <Iconmoon
                                                      icon={
                                                        sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                      }
                                                      size={14}
                                                      color="#EA4E2C"
                                                    />
                                                  </Button>
                                                )}
                                              </span>
                                            }
                                            key="3"
                                          // disabled={solutionSummary?.solution1.exception}
                                          >
                                            <TableLayoutData>
                                              <div
                                                className="tableDataFormat"
                                                style={{ marginTop: "25px" }}
                                              >
                                                <Table
                                                  columns={orderFulfillmentColumnsHead}
                                                  dataSource={stockSizeDetailsList1}
                                                  onChange={onChange}
                                                  scroll={{ x: 1800 }}
                                                  rowClassName={(record) =>
                                                    record.priority && "true"
                                                  }
                                                />
                                              </div>
                                            </TableLayoutData>
                                          </Panes>
                                        )}
                                      {/* <Panes
                                          tab={
                                   <span>
                                       Unfulfilled Orders
                                       {activeTab == "4" && (
                                         <Button
                                           key="1"
                                           style={{ border: "none" }}
                                           onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                         >
                                           <Iconmoon
                                             icon={
                                               sizeExpanded ? "contract_arrow" : "expand_arrow"
                                             }
                                             size={14}
                                             color="#EA4E2C"
                                           />
                                         </Button>
                                       )}
                                     </span>
                                   }     
                                                                         key="4"
                                      // disabled={solutionSummary?.solution1.exception}
                                    >
                                      <TableLayoutData>
                                        <div
                                          className="tableDataFormat"
                                          style={{ marginTop: "25px" }}
                                        >
                                          <Table
                                            columns={unfulfilledColumnsHead}
                                            dataSource={
                                              job.newlyCreatedJobCardsDetails[0]
                                                .jobcard?.solution_1.data
                                                .exception
                                                ? failedJobOrders
                                                : stockSizeDetailsList1?.filter(
                                                    (order) =>
                                                      order.unFulflilledReels >
                                                      0
                                                  )
                                            }
                                            onChange={onChange}
                                            scroll={{ x: 1800 }}
                                            rowClassName={(record) =>
                                              record.priority && "true"
                                            }
                                          />
                                        </div>
                                      </TableLayoutData>
                                    </Panes> */}
                                    </Tabs>
                                  </Col>
                                </Row>
                              </div>
                            </Panes>
                          )}

                          {job.newlyCreatedJobCardsDetails &&
                            (
                              <Panes tab="New Solution 2" key="4">
                                <PageTitleComp style={{ borderBottom: "0" }}>
                                  <PageHeader
                                    ghost={false}
                                    title={
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "50px",
                                        }}
                                      >
                                        <span>{job.state == "pending" ? (activeJC && activeJC != undefined ? activeJC : "") : ("Job Card " + (activeJC && activeJC != undefined ? activeJC : ""))}</span>
                                        {/* {job.state == "pending" ? (
                                        (activeJC?.length > 20 ? (
                                          <Tooltip placement="bottomLeft" title={activeJC}>
                                            {activeJC?.slice(0,21)+"..."}
                                          </Tooltip>
                                          ) : (
                                            activeJC
                                        ))
                                        ) : (
                                        ("Job Card " + activeJC)
                                        )
                                      } */}
                                      </div>
                                    }
                                    extra={
                                      !job.newlyCreatedJobCardsDetails[0].jobcard
                                        ?.solution_2.data.exception && [
                                        job.newlyCreatedJobCardsDetails[0].jobcard
                                          ?.solution_2.data.status == "accept" ? (
                                          <AlertContainer
                                            color="green"
                                            icon={alertGreen}
                                            msg="The solution is sent for approval"
                                          />
                                        ) : job.newlyCreatedJobCardsDetails[0]
                                          ?.jobcard?.solution_2.data.status ==
                                          "reject" ? (
                                          job.newlyCreatedJobCardsDetails[0]
                                            ?.jobcard?.solution_1.data.status ==
                                            "accept" ? (
                                            <AlertContainer
                                              color="green"
                                              icon={alertGreen}
                                              msg="The new solution 1 is already accepted"
                                            />
                                          ) : job.jobcard?.solution_1.data
                                            ?.status == "accept" ? (
                                            <AlertContainer
                                              color="green"
                                              icon={alertGreen}
                                              msg="The solution 1 is already accepted"
                                            />
                                          ) : job.jobcard?.solution_2.data
                                            .status == "accept" ? (
                                            <AlertContainer
                                              color="green"
                                              icon={alertGreen}
                                              msg="The solution 2 is already accepted"
                                            />
                                          ) : (
                                            <AlertContainer
                                              color="red"
                                              icon={alertRed}
                                              msg="The solution is discarded by the user"
                                            />
                                          )
                                        ) : job.newlyCreatedJobCardsDetails[0].jobcard
                                          ?.solution_2.data
                                          .summary ? (
                                          <RightSideSolution>
                                            <div className="rightSideSolutionButtons">
                                              <Button
                                                key="1"
                                                className="themeBtn noBg"
                                                onClick={() =>
                                                  discardModalShow("solution2")
                                                }
                                              // disabled={
                                              //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.data.exception
                                              // }
                                              >
                                                <Iconmoon
                                                  icon="wrong"
                                                  size={14}
                                                  color="#EA4E2C"
                                                />
                                                Discard Solution
                                              </Button>

                                              <Button
                                                key="2"
                                                className="themeBtn"
                                                onClick={() =>
                                                  acceptModalShow("solution2")
                                                }
                                              // disabled={
                                              //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.data.exception
                                              // }
                                              >
                                                <Iconmoon
                                                  icon="correct"
                                                  size={14}
                                                  color="#ffffff"
                                                />
                                                Accept Solution
                                              </Button>
                                            </div>
                                          </RightSideSolution>
                                        ) : '',
                                      ]
                                    }
                                  ></PageHeader>
                                </PageTitleComp>
                                <div className="MatchResult">
                                  <Row span={24} className="pipeBlockCylinder">
                                    {(
                                      ((!sizeExpanded && activeTab == '2') ||
                                        (!sizeExpanded && activeTab == '3') ||
                                        (!sizeExpanded && activeTab == '4') ||
                                        (!sizeExpanded && activeTab == '5')) || activeTab == '1') && (<Col
                                          span={14}
                                          className="pipeBlock"
                                          style={{ paddingRight: "20px" }}
                                        >
                                          <RightSideSolution>
                                            {!job.newlyCreatedJobCardsDetails[0]
                                              .jobcard?.solution_2.data.exception && solutionId == '4' && job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.partitions &&
                                              job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.partitions
                                                .length ? (
                                              // jobCardDetailsList && (
                                              cutter.type == 'simplex' ? <SheetJobCardCylinderContainer
                                                jobId={
                                                  job.newlyCreatedJobCardsDetails[0]
                                                    .id
                                                }
                                                solution={2}
                                                multiView={true}
                                                deckle_match_page={true}
                                                acceptedSolution={
                                                  job.newlyCreatedJobCardsDetails[0]
                                                    .jobcard?.solution_2.data
                                                }
                                                jobCard={job.newlyCreatedJobCardsDetails[0].jobcard}
                                                unitData={unitData}
                                              /> :
                                                <DuplexJobCardCylinderContainer
                                                  jobId={
                                                    job.newlyCreatedJobCardsDetails[0]
                                                      .id
                                                  }
                                                  solution={2}
                                                  multiView={true}
                                                  deckle_match_page={true}
                                                  acceptedSolution={
                                                    job.newlyCreatedJobCardsDetails[0]
                                                      .jobcard?.solution_2.data
                                                  }
                                                  jobCard={job.newlyCreatedJobCardsDetails[0].jobcard}
                                                  unitData={unitData}
                                                />
                                            ) : (
                                              // )
                                              <>
                                                <div className="deckleCoverImage">
                                                  <img
                                                    src={deckleCover}
                                                    alt="deckle match result"
                                                  />
                                                </div>
                                                {/* Exception message */}
                                                <div className="colLayoutBlock deckleErrorLayout">
                                                  <p style={{ color: "#EA655B" }}>
                                                    {
                                                      job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.solution_2.data
                                                        .exception
                                                    }
                                                  </p>
                                                </div>
                                              </>
                                            )}
                                          </RightSideSolution>
                                        </Col>
                                      )}
                                    <Col span={
                                      ((sizeExpanded && activeTab == '2') ||
                                        (sizeExpanded && activeTab == '3') ||
                                        (sizeExpanded && activeTab == '4') ||
                                        (sizeExpanded && activeTab == '5')) && activeTab != '1'
                                        ? 24
                                        : 9
                                    } className="colLayoutBlock">
                                      {/* Exception message */}
                                      {/* {!jobCardDetailsList[jobIndex]?.solution2.summary ? (
                            <></>
                          ) : (
                            <p style={{ color: "#EA655B" }}>
                              {job.solution2.exception}
                            </p>
                          )} */}

                                      <Tabs
                                        defaultActiveKey={activeTab}
                                        activeKey={activeTab}
                                        onChange={tabChange}
                                        className="topPostTab innerPostTab"
                                      >
                                        <Panes
                                          tab="Solution 2 summary"
                                          key="1"
                                        // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                        >
                                          <div className="lossValue">
                                            {!job.newlyCreatedJobCardsDetails[0]
                                              .jobcard?.solution_2.data
                                              .exception && job.newlyCreatedJobCardsDetails[0]
                                                .jobcard?.solution_2.data.summary && (
                                                <>
                                                  <Row span={24}>
                                                    <Col span={12}>
                                                      <div className="summaryValue">
                                                        <h5>
                                                          <span className="trimCut"></span>{" "}
                                                          Trim Loss
                                                        </h5>
                                                        <span>
                                                          {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.summary.match_trimloss_percent_area.toFixed(3)} %`}
                                                        </span>
                                                        {
                                                          // job.jobcard.solution_1.data.summary
                                                          //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                          job.newlyCreatedJobCardsDetails[0]
                                                            .jobcard?.comparison['match_area_trim_loss_(a-b)'] <
                                                            0 ? (
                                                            <span className="lesserSolution">
                                                              <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                              {job.newlyCreatedJobCardsDetails[0]
                                                                .jobcard?.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                                  job.newlyCreatedJobCardsDetails[0]
                                                                    .jobcard?.comparison['match_area_trim_loss_(a-b)']
                                                                ).toFixed(2) : 0}
                                                              % pts greater than new sol 1
                                                            </span>
                                                          ) : (
                                                            <span className="lesserSolution">
                                                              <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                              {job.newlyCreatedJobCardsDetails[0]
                                                                .jobcard?.comparison['match_area_trim_loss_(a-b)'] ? Math.abs(
                                                                  job.newlyCreatedJobCardsDetails[0]
                                                                    .jobcard?.comparison['match_area_trim_loss_(a-b)']
                                                                ).toFixed(2) : 0}
                                                              % pts lesser than new sol 1
                                                            </span>
                                                          )
                                                          // ) : (
                                                          //   <></>
                                                          // )
                                                        }
                                                      </div>
                                                    </Col>
                                                    <Col span={12}>
                                                      <div className="summaryValue">
                                                        <h5>
                                                          <span className="trimBox"></span>{" "}
                                                          Fulfillment
                                                        </h5>
                                                        <span>
                                                          {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.summary.total_fulfillment_percent.toFixed(
                                                            3
                                                          )} %`}
                                                        </span>

                                                        {
                                                          // job.jobcard.solution_1.data.summary
                                                          //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard?.comparison
                                                          ['total_fulfillment_weight%_(a-b)'] <
                                                            0 ? (
                                                            <span className="lesserSolution">
                                                              <img src={greaterRange} style={{ "marginRight": "10px" }} />
                                                              {job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                .jobcard?.comparison
                                                              ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                                job
                                                                  .newlyCreatedJobCardsDetails[0]
                                                                  .jobcard?.comparison
                                                                ['total_fulfillment_weight%_(a-b)']
                                                              ).toFixed(2) : 0}
                                                              % pts greater than new sol 1
                                                            </span>
                                                          ) : (
                                                            <span className="lesserSolution">
                                                              <img src={lowerRange} style={{ "marginRight": "10px" }} />
                                                              {job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                .jobcard?.comparison
                                                              ['total_fulfillment_weight%_(a-b)'] ? Math.abs(
                                                                job
                                                                  .newlyCreatedJobCardsDetails[0]
                                                                  .jobcard?.comparison
                                                                ['total_fulfillment_weight%_(a-b)']
                                                              ).toFixed(2) : 0}
                                                              % pts lesser than new sol 1
                                                            </span>
                                                          )
                                                          // ) : (
                                                          //   <></>
                                                          // )
                                                        }
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                  <Row span={24}>
                                                    <Col span={12}>
                                                      <div className="summaryValue">
                                                        <h5>
                                                          <span className="trimCut"></span>{" "}
                                                          Net Trim Loss:{" "}
                                                          {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.summary.net_trimloss_percent_area?.toFixed(
                                                            3
                                                          )} `}
                                                          %
                                                          <p>
                                                            Loss including edge trim
                                                          </p>
                                                        </h5>
                                                      </div>
                                                    </Col>
                                                    <Col span={12}>
                                                      <div className="summaryValue">
                                                        <h5>
                                                          <span className="trimBox"></span>{" "}
                                                          Weight:{" "}
                                                          {`${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.summary.job_card_weight?.toFixed(
                                                            3
                                                          )} ${capitalize(weightUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.summary.units?.job_card_weight]?.displayName)}`}

                                                          <p className="lesserSolution">
                                                            Total weight of Job Card
                                                          </p>
                                                        </h5>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </>
                                              )}
                                            <Row span={24}>
                                              <Col span={12}>
                                                <ul>
                                                  <li>
                                                    <span>Paper Machine</span>
                                                    <p>
                                                      {
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.group
                                                          .machines[0].name
                                                      }
                                                    </p>
                                                  </li>
                                                  <li>
                                                    <span>Deckle Width</span>
                                                    <p>{`${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].deckle_length_ub?.toFixed(
                                                      3
                                                    )} - ${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].deckle_length_lb?.toFixed(
                                                      3
                                                    )} ${(lengthUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].units?.deckle_length_ub]?.displayName).toUpperCase()}`}</p>
                                                  </li>

                                                  <li>
                                                    <span>
                                                      Product Specifications
                                                    </span>
                                                    <p style={{ wordWrap: "break-word" }}>
                                                      {
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.group.product
                                                          .product_spec
                                                      }
                                                    </p>
                                                  </li>
                                                  <li>
                                                    <span>
                                                      Weight of Fulfilled Sheets
                                                    </span>
                                                    <p>
                                                      {/* {console.log(
                                                "i",
                                                job.jobcard.solution_2.data.data
                                                  .summary.requirement_fulfilled
                                              )} */}
                                                      {job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.solution_2.data
                                                        .summary
                                                        ?.total_fulfillment_weight
                                                        ? ` ${job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.summary.total_fulfillment_weight.toFixed(
                                                          3
                                                        )} ${capitalize(weightUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.solution_2.data.summary.units?.total_fulfillment_weight]?.displayName)}`
                                                        : 0}
                                                    </p>
                                                  </li>
                                                </ul>
                                              </Col>
                                              <Col span={12}>
                                                <ul>
                                                  <li>
                                                    <span>Cutter</span>
                                                    <p>
                                                      {
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.group
                                                          .machines[0].cutter_name
                                                      }
                                                    </p>
                                                  </li>
                                                  <li>
                                                    <span>
                                                      Edge Trim ( Left / Right)
                                                    </span>
                                                    <p>{`${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].left_edge_trim} ${(lengthUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].units?.left_edge_trim]?.displayName).toUpperCase()} / ${job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].right_edge_trim} ${(lengthUnit[job.newlyCreatedJobCardsDetails[0].jobcard?.group.machines[0].units?.right_edge_trim]?.displayName).toUpperCase()}`}</p>
                                                  </li>
                                                  <li>
                                                    <span>
                                                      Number of Unique Sets
                                                    </span>
                                                    <p>
                                                      {job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.solution_2.data
                                                        ?.summary
                                                        ?.total_unique_patterns
                                                        ? job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.solution_2
                                                          .data.summary
                                                          ?.total_unique_patterns
                                                        : 0}
                                                    </p>
                                                  </li>
                                                  <li>
                                                    <span>
                                                      Weight of Priority Sheets
                                                    </span>
                                                    <p>
                                                      {job
                                                        .newlyCreatedJobCardsDetails[0]
                                                        .jobcard?.solution_2.data
                                                        .summary
                                                        ?.fulfillment_priority_fulfillment_weight
                                                        ? job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard?.solution_2
                                                          .data.summary
                                                          ?.fulfillment_priority_fulfillment_weight.toFixed(3) + ' ' + capitalize(weightUnit[job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard?.solution_2
                                                            .data.summary?.units
                                                            ?.fulfillment_priority_fulfillment_weight]?.displayName)
                                                        : 0}
                                                    </p>
                                                  </li>
                                                </ul>
                                              </Col>
                                            </Row>
                                            {/* Removed Approved Remarks     */}
                                          </div>
                                        </Panes>
                                        <Panes
                                          tab={
                                            <span>
                                              Size Fulfilment
                                              {activeTab == "2" && (
                                                <Button
                                                  key="1"
                                                  style={{ border: "none" }}
                                                  onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                                >
                                                  <Iconmoon
                                                    icon={
                                                      sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                    }
                                                    size={14}
                                                    color="#EA4E2C"
                                                  />
                                                </Button>
                                              )}
                                            </span>
                                          }
                                          key="2">
                                          <TableLayoutData>
                                            <div
                                              className="tableDataFormat  "
                                              style={{ marginTop: "25px" }}
                                            >
                                              <Table
                                                columns={
                                                  sizeFulfillmentColumnsHead
                                                }
                                                dataSource={
                                                  sizeFulfillmentNewSolution2
                                                }
                                                onChange={onChange}
                                                scroll={{ x: 1200 }}
                                                rowClassName={(record) =>
                                                  record.priority && "true"
                                                }
                                              />
                                            </div>
                                          </TableLayoutData>
                                        </Panes>
                                        {!job.newlyCreatedJobCardsDetails[0]
                                          .jobcard?.solution_2.data.exception && (
                                            <Panes
                                              tab={
                                                <span>
                                                  Order Fulfillment
                                                  {activeTab == "3" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded ? "contract_arrow" : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="3"
                                            // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={orderFulfillmentColumnsHead}
                                                    dataSource={stockSizeDetailsList2}
                                                    onChange={onChange}
                                                    scroll={{ x: 1800 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                          )}
                                        {/* <Panes
                                          tab={
                                   <span>
                                       Unfulfilled Orders
                                       {activeTab == "4" && (
                                         <Button
                                           key="1"
                                           style={{ border: "none" }}
                                           onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                         >
                                           <Iconmoon
                                             icon={
                                               sizeExpanded ? "contract_arrow" : "expand_arrow"
                                             }
                                             size={14}
                                             color="#EA4E2C"
                                           />
                                         </Button>
                                       )}
                                     </span>
                                   }                                            
                                    key="4"
                                        // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                      >
                                        <TableLayoutData>
                                          <div
                                            className="tableDataFormat"
                                            style={{ marginTop: "25px" }}
                                          >
                                            <Table
                                              columns={unfulfilledColumnsHead}
                                              dataSource={
                                                job
                                                  .newlyCreatedJobCardsDetails[0]
                                                  .jobcard?.solution_1.data
                                                  .exception
                                                  ? failedJobOrders
                                                  : stockSizeDetailsList2?.filter(
                                                      (order) =>
                                                        order.unFulflilledReels >
                                                          0 &&
                                                        order.type == "Order"
                                                    )
                                              }
                                              onChange={onChange}
                                              scroll={{ x: 1800 }}
                                              rowClassName={(record) =>
                                                record.priority && "true"
                                              }
                                            />
                                          </div>
                                        </TableLayoutData>
                                      </Panes> */}
                                      </Tabs>
                                    </Col>
                                  </Row>
                                </div>
                              </Panes>
                            )}
                        </Tabs>
                      </>
                    )
                  )}
                </TabPane>
              ))}

              {failedJobs && failedJobs.length &&
                failedJobs?.map((failedJob, index) => (
                  <TabPane
                    key={failedJob.id}
                    tab={
                      <div className="deckleMatchIcon disabled">
                        <img src={failedIco} />
                        {"JC " + (jobCardDetailsList.length + index + 1) + "(failed)"}
                      </div>
                    }
                    style={{ backgroundColor: "rgb(255, 255, 255)", borderLeft: "1px solid rgb(235, 235, 235)" }}
                  >
                    <PageTitleComp style={{ borderBottom: "0", backgroundColor: "rgb(255, 255, 255)" }}>
                      <PageHeader ghost={false} title="Job Card"></PageHeader>
                    </PageTitleComp>
                    <div className="MatchResult" style={{ backgroundColor: "rgb(255, 255, 255)" }}>
                      <Row span={24} className="pipeBlockCylinder">
                        {(
                          ((!sizeExpanded && activeTab == '2') ||
                            (!sizeExpanded && activeTab == '3') ||
                            (!sizeExpanded && activeTab == '4') ||
                            (!sizeExpanded && activeTab == '5')) || activeTab == '1') && (<Col
                              span={14}
                              className="pipeBlock"
                              style={{ paddingRight: "20px" }}
                            >
                              <RightSideSolution>
                                <div className="deckleCoverImage">
                                  <img
                                    src={deckleCover}
                                    alt="deckle match result"
                                  />
                                </div>
                                {cutter.type == 'duplex' && (<div className="colLayoutBlock deckleErrorLayout">
                                  <p style={{ color: "#EA655B" }}>
                                    {
                                      failedJob.group.exception
                                    }
                                  </p>
                                </div>
                                )}
                              </RightSideSolution>
                            </Col>
                          )}
                        <Col span={
                          ((sizeExpanded && activeTab == '2') ||
                            (sizeExpanded && activeTab == '3') ||
                            (sizeExpanded && activeTab == '4') ||
                            (sizeExpanded && activeTab == '5')) && activeTab != '1'
                            ? 24
                            : 9
                        } className="colLayoutBlock">
                          <Tabs
                            defaultActiveKey={activeTab}
                            activeKey={activeTab}
                            onChange={tabChange}
                            className="topPostTab innerPostTab"
                          >
                            <Panes tab="Summary" key="1">
                              <div className="lossValue">
                                <Row span={24}>
                                  <Col span={12}>
                                    <ul>
                                      <li>
                                        <span>Paper Machine</span>
                                        <p>
                                          {
                                            failedJob.group.machines[0]
                                              .machine_id
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>Deckle Width</span>
                                        <p>
                                          {`${failedJob.group.machines[0].deckle_length_ub?.toFixed(
                                            3
                                          )} - ${failedJob.group.machines[0].deckle_length_lb?.toFixed(
                                            3
                                          )} ${lengthUnit[failedJob.group.machines[0]?.units?.deckle_length_ub]?.displayName}`}

                                        </p>
                                      </li>

                                      <li>
                                        <span>Product Specifications</span>
                                        <p style={{ wordWrap: "break-word" }}>
                                          {failedJob.group.product.product_spec}
                                        </p>
                                      </li>
                                      <li>
                                        <span>Weight of Fulfilled Sheets</span>
                                        <p>0</p>
                                      </li>
                                    </ul>
                                  </Col>
                                  <Col span={12}>
                                    <ul>
                                      <li>
                                        <span>Cutter</span>
                                        <p>
                                          {
                                            failedJob.group.machines[0]
                                              .cutter_name
                                          }
                                        </p>
                                      </li>
                                      <li>
                                        <span>Edge Trim ( Left / Right)</span>
                                        <p>{`${failedJob.group.machines[0].left_edge_trim} ${(lengthUnit[failedJob.group.machines[0].units?.left_edge_trim]?.displayName).toUpperCase()} / ${failedJob.group.machines[0].right_edge_trim} ${(lengthUnit[failedJob.group.machines[0].units?.right_edge_trim]?.displayName).toUpperCase()}`}</p>
                                      </li>
                                      <li>
                                        <span> Number of Unique Sets</span>
                                        <p>0</p>
                                      </li>
                                      <li>
                                        <span>Weight of Priority Sheets</span>
                                        <p>0</p>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                              </div>
                            </Panes>
                            {/* <Panes
                                          tab={
                                   <span>
                                       Unfulfilled Orders
                                       {activeTab == "4" && (
                                         <Button
                                           key="1"
                                           style={{ border: "none" }}
                                           onClick={(e) => setSizeExpanded(!sizeExpanded)}
                                         >
                                           <Iconmoon
                                             icon={
                                               sizeExpanded ? "contract_arrow" : "expand_arrow"
                                             }
                                             size={14}
                                             color="#EA4E2C"
                                           />
                                         </Button>
                                       )}
                                     </span>
                                   }                                   
                                   key="4"
                              // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                            >
                              <TableLayoutData>
                                <div
                                  className="tableDataFormat"
                                  style={{ marginTop: "25px" }}
                                >
                                  <Table
                                    columns={unfulfilledColumnsHead}
                                    dataSource={failedJobOrders}
                                    onChange={onChange}
                                    scroll={{ x: 1800 }}
                                    rowClassName={(record) =>
                                      record.priority && "true"
                                    }
                                  />
                                </div>
                              </TableLayoutData>
                            </Panes> */}
                          </Tabs>
                        </Col>
                      </Row>
                    </div>
                    {/* </Panes> */}
                  </TabPane>
                ))}
            </Tabs>
          ) : null}
        </DetailFields>
      </ResultWrap1>

      {/* Accept Modal */}
      <ModalPopup visible={isAcceptModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Send for approval?</span>
          <p>
            You are about to remove this order group, are you sure you want to
            continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => acceptModalClose()}
          // disabled={solutionSummary?.solution2.exception}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => acceptModalConfirm()}
          // disabled={solutionSummary?.solution2.exception}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      {/* Discard Modal */}
      <ModalPopup visible={isDiscardModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Discard the solution?</span>
          <p>
            You are about to discard this order group, are you sure you want to
            continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => discardModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => discardModalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      <ViewDeckleOrder
        selectedOrderNo={selectedOrderNo}
        // showButton={true}
        visible={viewOrder}
        onClose={closeViewDrawer}
        onCloseGrade={closeViewDrawer}
        category={selectedOrder?.category}

      />
    </RightLayoutContainer>
  ) : null;
};
export default SheetDeckleResultsData;
